(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('reflect-metadata'), require('tsyringe'), require('js-cookie'), require('axios'), require('react'), require('react-dom'), require('i18next-browser-languagedetector'), require('react-i18next'), require('i18next'), require('numeral'), require('jwt-decode')) :
    typeof define === 'function' && define.amd ? define(['exports', 'reflect-metadata', 'tsyringe', 'js-cookie', 'axios', 'react', 'react-dom', 'i18next-browser-languagedetector', 'react-i18next', 'i18next', 'numeral', 'jwt-decode'], factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory(global["{fileName}"] = {}, null, global.tsyringe, global.Cookies, global.axios, global.React, global.ReactDOM, global.LanguageDetector, global.reactI18next, global.i18next, global.numeral, global.jwtDecode));
})(this, (function (exports, reflectMetadata, tsyringe, Cookies, axios, React, ReactDOM, LanguageDetector, reactI18next, i18next, numeral, jwtDecode) { 'use strict';

    function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

    var Cookies__default = /*#__PURE__*/_interopDefaultLegacy(Cookies);
    var axios__default = /*#__PURE__*/_interopDefaultLegacy(axios);
    var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
    var ReactDOM__default = /*#__PURE__*/_interopDefaultLegacy(ReactDOM);
    var LanguageDetector__default = /*#__PURE__*/_interopDefaultLegacy(LanguageDetector);
    var i18next__default = /*#__PURE__*/_interopDefaultLegacy(i18next);
    var numeral__default = /*#__PURE__*/_interopDefaultLegacy(numeral);
    var jwtDecode__default = /*#__PURE__*/_interopDefaultLegacy(jwtDecode);

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation.

    Permission to use, copy, modify, and/or distribute this software for any
    purpose with or without fee is hereby granted.

    THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
    REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
    AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
    INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
    LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
    OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
    PERFORMANCE OF THIS SOFTWARE.
    ***************************************************************************** */

    function __decorate(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    }

    function __metadata(metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
    }

    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }

    class RequiredValidator {
        static registerRequired(target, property) {
            let keys = RequiredValidator.requiredValidatorMap.get(target);
            if (!keys) {
                keys = [];
                this.requiredValidatorMap.set(target, keys);
            }
            keys.push(property);
        }
        static validate(target) {
            let isValid = true;
            let errorMessages = [];
            const requiredProps = RequiredValidator.requiredValidatorMap.get(Object.getPrototypeOf(target));
            if (requiredProps) {
                for (const property of requiredProps) {
                    const value = target[property];
                    if (value === undefined || value === null) {
                        isValid = false;
                        errorMessages = [...errorMessages, `Property, ${property}, is required but not defined.`];
                    }
                }
            }
            return isValid ? { isValid } : { isValid, errorMessages };
        }
    }
    RequiredValidator.requiredValidatorMap = new Map();
    const required = (target, propertyKey) => {
        RequiredValidator.registerRequired(target, propertyKey);
    };

    /**
     * BaseError class
     * Initiates standard Error object & logs error.message
     */
    let BaseError = class BaseError extends Error {
        /**
         * @param {string} message - the error message passed to Error object
         */
        constructor(message) {
            super(message);
            this.name = this.constructor.name;
        }
    };
    BaseError = __decorate([
        tsyringe.injectable(),
        __metadata("design:paramtypes", [String])
    ], BaseError);

    const MISSING_DATA_ERROR = 'aw-geolocation/missing-data-error';
    const IN_PROGRESS_ERROR = 'aw-geolocation/in-progress-error';
    const SETTING_LICENSE_ERROR = 'aw-geolocation/setting-license-error';
    const LOCATION_REQUEST_ERROR = 'aw-geolocation/location-request-error';
    const LOCATION_PERMISSIONS_ERROR = 'aw-geolocation/location-permissions-error';
    const NO_LOCATION_SERVICES_ERROR = 'aw-geolocation/no-location-services-error';
    const FETCH_LICENSE_ERROR = 'aw-geolocation/fetch-license-error';
    const FETCH_LICENSE_WITHOUT_RETRY_ERROR = 'aw-geolocation/fetch-license-without-retry-error';
    const REFRESH_LICENSE_ERROR = 'aw-geolocation/refresh-license-error';
    const REFRESH_LICENSE_WITHOUT_RETRY_ERROR = 'aw-geolocation/refresh-license-without-retry-error';
    const SUBMIT_ERROR = 'aw-geolocation/submit-error';
    const SUBMIT_WITHOUT_RETRY_ERROR = 'aw-geolocation/submit-without-retry-error';
    const GEOCOMPLY_ERROR = 'aw-geolocation/geocomply-error';
    const API_ERROR = 'aw-geolocation/api-error';
    const THRESHOLD_LIMIT_ERROR = 'aw-geolocation/threshold-limit-error';
    const PLC_ERROR = 'aw-geolocation/plc-error';
    const OS_ERROR = 'aw-geolocation/os-error';
    var GCError;
    (function (GCError) {
        GCError[GCError["CLIENT_OK"] = 0] = "CLIENT_OK";
        GCError[GCError["UNEXPECTED"] = 600] = "UNEXPECTED";
        GCError[GCError["NOT_CERTIFIED_BINARIES"] = 601] = "NOT_CERTIFIED_BINARIES";
        GCError[GCError["NETWORK_CONNECTION"] = 602] = "NETWORK_CONNECTION";
        GCError[GCError["SERVER_COMMUNICATION"] = 603] = "SERVER_COMMUNICATION";
        GCError[GCError["CLIENT_SUSPENDED"] = 604] = "CLIENT_SUSPENDED";
        GCError[GCError["DISABLED_SOLUTION"] = 605] = "DISABLED_SOLUTION";
        GCError[GCError["INVALID_LICENSE_FORMAT"] = 606] = "INVALID_LICENSE_FORMAT";
        GCError[GCError["CLIENT_LICENSE_UNAUTHORIZED"] = 607] = "CLIENT_LICENSE_UNAUTHORIZED";
        GCError[GCError["LICENSE_EXPIRED"] = 608] = "LICENSE_EXPIRED";
        GCError[GCError["INVALID_CUSTOM_FIELDS"] = 609] = "INVALID_CUSTOM_FIELDS";
        GCError[GCError["LOCAL_SERVICE_UNAVAILABLE"] = 612] = "LOCAL_SERVICE_UNAVAILABLE";
        GCError[GCError["LOCAL_SERVICE_COMMUNICATION"] = 613] = "LOCAL_SERVICE_COMMUNICATION";
        GCError[GCError["REQUEST_GEOLOCATION_IN_PROGRESS"] = 614] = "REQUEST_GEOLOCATION_IN_PROGRESS";
        GCError[GCError["LOCAL_SERVICE_UNSUP_VER"] = 615] = "LOCAL_SERVICE_UNSUP_VER";
        GCError[GCError["TRANSACTION_TIMEOUT"] = 620] = "TRANSACTION_TIMEOUT";
        GCError[GCError["WRONG_OR_MISSING_PARAMETER"] = 699] = "WRONG_OR_MISSING_PARAMETER";
        GCError[GCError["API_ERROR"] = 700] = "API_ERROR";
        GCError[GCError["MISSING_DATA_ERROR"] = 703] = "MISSING_DATA_ERROR";
        GCError[GCError["FETCH_LICENSE_WITHOUT_RETRY_ERROR"] = 706] = "FETCH_LICENSE_WITHOUT_RETRY_ERROR";
        GCError[GCError["FETCH_LICENSE_ERROR"] = 707] = "FETCH_LICENSE_ERROR";
        GCError[GCError["SUBMIT_ERROR_WITHOUT_RETRY"] = 708] = "SUBMIT_ERROR_WITHOUT_RETRY";
        GCError[GCError["SUBMIT_ERROR"] = 711] = "SUBMIT_ERROR";
        GCError[GCError["THRESHOLD_LIMIT_ERROR"] = 713] = "THRESHOLD_LIMIT_ERROR";
        GCError[GCError["OS_ERROR"] = 714] = "OS_ERROR";
        GCError["DECRYPTION_SB2"] = "SB.2";
        GCError["DECRYPTION_SB3"] = "SB.3";
        GCError["DECRYPTION_SB4"] = "SB.4";
        GCError["DECRYPTION_SB6"] = "SB.6";
        GCError["DECRYPTION_SB7"] = "SB.7";
        GCError["DECRYPTION_SB8"] = "SB.8";
        GCError[GCError["UNKNOWN"] = 1] = "UNKNOWN";
    })(GCError || (GCError = {}));

    let MissingDataError = class MissingDataError extends BaseError {
        constructor(message = MISSING_DATA_ERROR) {
            super(message);
        }
    };
    MissingDataError = __decorate([
        tsyringe.injectable(),
        __metadata("design:paramtypes", [Object])
    ], MissingDataError);

    let GeoComplyError = class GeoComplyError extends BaseError {
        constructor(errorCode, message = GEOCOMPLY_ERROR) {
            super(message);
            this.errorCode = errorCode;
        }
    };
    GeoComplyError = __decorate([
        tsyringe.injectable(),
        __metadata("design:paramtypes", [Number, Object])
    ], GeoComplyError);

    let FetchLicenseError = class FetchLicenseError extends BaseError {
        constructor(message = FETCH_LICENSE_ERROR) {
            super(message);
        }
    };
    FetchLicenseError = __decorate([
        tsyringe.injectable(),
        __metadata("design:paramtypes", [Object])
    ], FetchLicenseError);

    let FetchLicenseWithoutRetryError = class FetchLicenseWithoutRetryError extends BaseError {
        constructor(message = FETCH_LICENSE_WITHOUT_RETRY_ERROR) {
            super(message);
        }
    };
    FetchLicenseWithoutRetryError = __decorate([
        tsyringe.injectable(),
        __metadata("design:paramtypes", [Object])
    ], FetchLicenseWithoutRetryError);

    let InProgressError = class InProgressError extends BaseError {
        constructor(message = IN_PROGRESS_ERROR) {
            super(message);
        }
    };
    InProgressError = __decorate([
        tsyringe.injectable(),
        __metadata("design:paramtypes", [Object])
    ], InProgressError);

    let LocationPermissionsError = class LocationPermissionsError extends BaseError {
        constructor(message = LOCATION_PERMISSIONS_ERROR) {
            super(message);
        }
    };
    LocationPermissionsError = __decorate([
        tsyringe.injectable(),
        __metadata("design:paramtypes", [Object])
    ], LocationPermissionsError);

    let LocationRequestError = class LocationRequestError extends BaseError {
        constructor(message = LOCATION_REQUEST_ERROR) {
            super(message);
        }
    };
    LocationRequestError = __decorate([
        tsyringe.injectable(),
        __metadata("design:paramtypes", [Object])
    ], LocationRequestError);

    let NoLocationServicesError = class NoLocationServicesError extends BaseError {
        constructor(message = NO_LOCATION_SERVICES_ERROR) {
            super(message);
        }
    };
    NoLocationServicesError = __decorate([
        tsyringe.injectable(),
        __metadata("design:paramtypes", [Object])
    ], NoLocationServicesError);

    let RefreshLicenseError = class RefreshLicenseError extends BaseError {
        constructor(message = REFRESH_LICENSE_ERROR) {
            super(message);
        }
    };
    RefreshLicenseError = __decorate([
        tsyringe.injectable(),
        __metadata("design:paramtypes", [Object])
    ], RefreshLicenseError);

    let RefreshLicenseWithoutRetryError = class RefreshLicenseWithoutRetryError extends BaseError {
        constructor(message = REFRESH_LICENSE_WITHOUT_RETRY_ERROR) {
            super(message);
        }
    };
    RefreshLicenseWithoutRetryError = __decorate([
        tsyringe.injectable(),
        __metadata("design:paramtypes", [Object])
    ], RefreshLicenseWithoutRetryError);

    let SettingLicenseError = class SettingLicenseError extends BaseError {
        constructor(message = SETTING_LICENSE_ERROR) {
            super(message);
        }
    };
    SettingLicenseError = __decorate([
        tsyringe.injectable(),
        __metadata("design:paramtypes", [Object])
    ], SettingLicenseError);

    let SubmitError = class SubmitError extends BaseError {
        constructor(message = SUBMIT_ERROR) {
            super(message);
        }
    };
    SubmitError = __decorate([
        tsyringe.injectable(),
        __metadata("design:paramtypes", [Object])
    ], SubmitError);

    let SubmitWithoutRetryError = class SubmitWithoutRetryError extends BaseError {
        constructor(message = SUBMIT_WITHOUT_RETRY_ERROR) {
            super(message);
        }
    };
    SubmitWithoutRetryError = __decorate([
        tsyringe.injectable(),
        __metadata("design:paramtypes", [Object])
    ], SubmitWithoutRetryError);

    let ThresholdLimitError = class ThresholdLimitError extends BaseError {
        constructor(message = THRESHOLD_LIMIT_ERROR) {
            super(message);
        }
    };
    ThresholdLimitError = __decorate([
        tsyringe.injectable(),
        __metadata("design:paramtypes", [Object])
    ], ThresholdLimitError);

    let ApiError = class ApiError extends BaseError {
        constructor(message = API_ERROR) {
            super(message);
        }
    };
    ApiError = __decorate([
        tsyringe.injectable(),
        __metadata("design:paramtypes", [Object])
    ], ApiError);

    let OsError = class OsError extends BaseError {
        constructor(message = OS_ERROR) {
            super(message);
        }
    };
    OsError = __decorate([
        tsyringe.injectable(),
        __metadata("design:paramtypes", [Object])
    ], OsError);

    const isBrowser = typeof window !== 'undefined';
    const toJson = (value) => JSON.stringify(value);
    const fromJson = (value) => {
        return JSON.parse(value);
    };
    const toDate = (dateString) => new Date(dateString);
    const isDateInstance = (date) => date instanceof Date;
    const ms = (value, period) => {
        const ms = 1000;
        const hrInDay = 24;
        const minInHr = 60;
        const secInMin = 60;
        if (period === 'days') {
            return value * hrInDay * minInHr * secInMin * ms;
        }
        if (period === 'hours') {
            return value * minInHr * secInMin * ms;
        }
        if (period === 'minutes') {
            return value * secInMin * ms;
        }
        if (period === 'seconds') {
            return value * ms;
        }
    };
    const osAgents = [
        ['mac', /(Mac_PowerPC)|(Macintosh)/],
        ['win', /Windows/],
    ];
    /**
     * @helper function to check if the user is on a mac or windows
     * @returns string to detect either mac or win for geolocation
     * @throws error if not windows or mac
     */
    const osDetection = (ua = navigator.userAgent) => {
        for (const osAgent of osAgents) {
            const [os, osRegex] = osAgent;
            if (osRegex.test(ua))
                return os;
        }
        throw new OsError();
    };
    /**
     * helper function to capitialise every word
     */
    const capitalise = (stringToFormat) => {
        return stringToFormat
            .toLowerCase()
            .split(' ')
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(' ');
    };
    /**
     * helper function to replace values
     * @param replaced value to be replaced or function
     * @returns function
     */
    const replace = (replaced) => (replaceWith) => (word) => {
        const regex = new RegExp(replaced, 'g');
        return word.replace(regex, replaceWith).trim();
    };
    /**
     * Pipe helper function
     * @param fns piping functions
     */
    const pipe = (...fns) => (arg) => fns.reduce((previousResult, fn) => fn(previousResult), arg);
    /**
     * try catch helper function that allows the error or result to accesible outside
     * the try catch block
     * @param {fn} callback function
     * @returns array of either result or error
     */
    const tryCatch = (cb) => {
        try {
            const result = cb();
            return [result, null];
        }
        catch (err) {
            return [null, err];
        }
    };

    class ValidatingSDKInitConfig {
        isValid() {
            var _a;
            const validationResult = RequiredValidator.validate(this);
            if (!validationResult.isValid) {
                const errorMessage = (_a = validationResult.errorMessages) === null || _a === void 0 ? void 0 : _a[0];
                throw new Error(errorMessage !== null && errorMessage !== void 0 ? errorMessage : 'UNKNOWN property is required but not defined.');
            }
            return validationResult.isValid;
        }
    }
    class BaseSDKInitConfig extends ValidatingSDKInitConfig {
        constructor(init) {
            super();
            Object.assign(this, init);
        }
    }
    __decorate([
        required,
        __metadata("design:type", String)
    ], BaseSDKInitConfig.prototype, "clientId", void 0);
    __decorate([
        required,
        __metadata("design:type", String)
    ], BaseSDKInitConfig.prototype, "environment", void 0);
    exports.BrowserStorageKeys = void 0;
    (function (BrowserStorageKeys) {
        BrowserStorageKeys["Auth"] = "xauthtoken";
        BrowserStorageKeys["SessionId"] = "sessionid";
        BrowserStorageKeys["Login"] = "xlogintoken";
        BrowserStorageKeys["UserId"] = "fdUserId";
        BrowserStorageKeys["LoginUrl"] = "fdLoginUrl";
    })(exports.BrowserStorageKeys || (exports.BrowserStorageKeys = {}));
    // in line with IWA and Sportsbook
    exports.CookieExpiry = void 0;
    (function (CookieExpiry) {
        CookieExpiry[CookieExpiry["Login"] = ms(30, 'days')] = "Login";
        CookieExpiry[CookieExpiry["Auth"] = ms(12, 'hours')] = "Auth";
        CookieExpiry[CookieExpiry["SessionId"] = ms(30, 'days')] = "SessionId";
        CookieExpiry[CookieExpiry["GeolocationToken"] = ms(2, 'hours')] = "GeolocationToken";
    })(exports.CookieExpiry || (exports.CookieExpiry = {}));

    const extractBaseDomain = (environment) => {
        switch (environment.toLowerCase()) {
            case 'prod':
                return 'https://api.fanduel.com';
            case 'qa':
                return stackBasedUrl('igtqa8');
            case 'dev':
                return stackBasedUrl('igtdev8');
            case 'dge-cert':
                return stackBasedUrl('dgecert1');
            case 'cert':
                return stackBasedUrl('igtcert1');
            default:
                if (environment.includes('http://') || environment.includes('https://')) {
                    return environment;
                }
                else {
                    return stackBasedUrl(environment);
                }
        }
    };
    const stackBasedUrl = (stackName) => {
        return `https://devstack-${stackName}-api.use1.dev.us.fdbox.net`;
    };

    let ConfigService = class ConfigService {
        /**
         * Creates config instance. Sets config object if passed as param
         * @param {ValidatingSDKInitConfig} config - optional
         */
        constructor(config) {
            if (config) {
                this.setConfig(config);
            }
        }
        /**
         * Updates the _config in the service, and calls the instance.prepareConfig method to parse the data
         * @param {ValidatingSDKInitConfig} config
         * @returns {void}
         * @throws Error is missing config property
         * @throws Error if missing enviroment or clientId
         */
        setConfig(config) {
            var _a;
            config.isValid();
            this._config = config;
            Object.assign(this, config);
            this.locale = config.locale || 'en-US';
            this.timeZone = config.timeZone || 'America/New_York';
            this.baseDomain = extractBaseDomain(config.environment);
            if ((_a = config.appDomain) === null || _a === void 0 ? void 0 : _a.region) {
                Cookies__default["default"].set('X-Region', config.appDomain.region);
                Cookies__default["default"].set('X-Sportsbook-Region', config.appDomain.region);
            }
        }
        /**
         * Explicit check for config service
         * @returns {boolean}
         */
        get isSet() {
            try {
                this._config.isValid();
                return true;
            }
            catch (e) {
                return false;
            }
        }
        /**
         * Explicit check for development setting
         * @returns {boolean}
         */
        get isDev() {
            return this.environment === 'dev';
        }
    };
    ConfigService = __decorate([
        tsyringe.injectable(),
        __metadata("design:paramtypes", [ValidatingSDKInitConfig])
    ], ConfigService);

    let LoggerService = class LoggerService {
        constructor(_configService) {
            this._configService = _configService;
        }
        log(message) {
            if (this._configService.onLog) {
                this._configService.onLog(message);
            }
        }
        error(message) {
            if (this._configService.onError) {
                this._configService.onError(message);
            }
        }
    };
    LoggerService = __decorate([
        tsyringe.singleton(),
        __metadata("design:paramtypes", [ConfigService])
    ], LoggerService);

    var getPXHeaderCookie = (storage) => {
        const pxCookies = localStorage.getItem('x-px-context');
        if (pxCookies) {
            let values = '';
            pxCookies.split(',').forEach((c) => {
                const cookie = storage.get(c);
                if (cookie) {
                    values += `${c}=${cookie};`;
                }
            });
            if (values !== '') {
                return values;
            }
        }
    };

    const objToQueryString = (obj) => {
        if (obj) {
            const keyValuePairs = [];
            for (const key in obj) {
                keyValuePairs.push(encodeURIComponent(key) + '=' + encodeURIComponent(obj[key]));
            }
            return '?' + keyValuePairs.join('&');
        }
        return '';
    };
    const storageFactory = () => {
        return {
            init: () => { },
            get: (name) => name && Cookies__default["default"].get(name),
            set: (name, value, options) => {
                Cookies__default["default"].set(name, value, options);
            },
            clear: (name, domain) => {
                Cookies__default["default"].remove(name || '', {
                    domain: domain || undefined,
                });
            },
            clearAllSubdomains: (name) => {
                const subdomainList = window.location.hostname.split('.');
                subdomainList
                    .reduce((acc, _curr, idx, arr) => {
                    acc.push(arr.slice(idx).join('.'));
                    return acc;
                }, [])
                    .map((domain) => {
                    Cookies__default["default"].remove(name, {
                        domain,
                    });
                });
                Cookies__default["default"].remove(name);
            },
        };
    };
    const getHeaders = (configService, extraHeaders) => {
        const pxCookies = configService.perimeterXAppID ? getPXHeaderCookie(storageFactory()) : undefined;
        const headerObj = Object.assign({ 'Content-Type': 'application/json', Accept: 'application/json', 'Cache-Control': 'no-cache' }, (pxCookies && {
            'x-px-context': pxCookies,
        }));
        if (configService === null || configService === void 0 ? void 0 : configService.clientId) {
            headerObj['Authorization'] = `Basic ${configService.clientId}`;
        }
        if (extraHeaders) {
            for (const property in extraHeaders) {
                headerObj[property] = extraHeaders[property];
            }
        }
        return headerObj;
    };

    class Modal {
        constructor(stylesheetId) {
            /**
             * @private Callback method passed to event listener for closing the modal when backdrop is clicked
             */
            this.closeOnWindowClick = (e) => {
                const modalEl = document.querySelector('.modal-container');
                if (e.target == modalEl) {
                    this.close();
                }
            };
            /**
             * @private Callback method passed to event listener to close modal when Esc key is pressed
             */
            this.closeOnEsc = (e) => {
                if (e.key === 'Esc' || e.key === 'Escape') {
                    this.close();
                }
            };
            this.stylesheetId = stylesheetId;
        }
        /**
         * @public Method to open the login modal
         * If the modal doesn't exist, it will create it
         */
        open(onClose) {
            if (!this._modal) {
                this.createModal();
            }
            this._modal.setAttribute('aria-hidden', 'false');
            this._modal.removeAttribute('hidden');
            this._modal.style.display = 'block';
            this._modal.style.visibility = 'visible';
            this.onClose = onClose;
        }
        /**
         * @public Method to close the modal
         */
        close() {
            var _a;
            if (!this._modal)
                return;
            this._modal = null;
            const modalElement = document.querySelector('.modal-item');
            if (modalElement) {
                this.removeModal(modalElement);
            }
            this.removeEventListeners();
            (_a = this.onClose) === null || _a === void 0 ? void 0 : _a.call(this);
        }
        addEventListeners() {
            document.addEventListener('click', this.closeOnWindowClick);
            document.addEventListener('keydown', this.closeOnEsc);
        }
        removeEventListeners() {
            document.removeEventListener('click', this.closeOnWindowClick);
            document.removeEventListener('keydown', this.closeOnEsc);
        }
        /**
         * @private Method to remove the modal and styles from the dom
         * @returns {void}
         */
        removeModal(element) {
            this.removeElement(element);
            this.removeStyleSheet(this.stylesheetId);
        }
        /**
         * @private Method to remove an element from the DOM
         * @param element to be removed
         */
        removeElement(element) {
            element.parentNode.removeChild(element);
        }
        /**
         * @private Method to remove stylesheet from the dom with the id
         * @param {id} stylesheet id
         */
        removeStyleSheet(id) {
            const styles = document.getElementById(id);
            if (styles !== null) {
                styles.disabled = true;
                styles.parentNode.removeChild(styles);
            }
        }
        /**
         * @public Method to create modal elements
         */
        createModal(styles = '') {
            this.removeEventListeners();
            this._modal = document.createElement('div');
            this._modal.classList.add('modal-item');
            this._modal.setAttribute('aria-hidden', 'true');
            this._modal.setAttribute('hidden', 'true');
            this._modal.setAttribute('role', 'dialog');
            this._modal.setAttribute('aria-modal', 'true');
            document.getElementsByTagName('body')[0].appendChild(this._modal);
            const modalContainer = document.createElement('div');
            modalContainer.classList.add('modal-container');
            this._modal.appendChild(modalContainer);
            const style = document.createElement('style');
            style.id = this.stylesheetId;
            style.innerHTML = styles;
            document.head.appendChild(style);
            this.addEventListeners();
        }
    }

    const FdLogo = () => {
        return (React__default["default"].createElement("svg", { viewBox: "0 0 353 76", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
            React__default["default"].createElement("title", null, "FanDuel"),
            React__default["default"].createElement("g", null,
                React__default["default"].createElement("path", { d: "M16.4475 29.1776C21.5223 26.8354 26.8834 25.4041 32.1404 24.7795C32.7129 24.7014 32.9471 25.0918 32.8951 25.5342C32.2185 29.568 31.776 33.6799 31.5939 37.7918C31.5418 38.2602 31.3076 38.5725 30.7611 38.6766C27.8463 39.2492 25.0096 40.134 21.8607 41.5653C24.6713 46.458 28.1066 50.9602 31.8541 54.7078C32.2965 55.1502 32.5307 55.6186 32.6609 56.3994C33.6498 62.6973 35.3414 69.0473 37.6316 75.059C37.7617 75.3973 37.7617 75.6315 37.5795 75.8137C37.3713 76.0219 37.033 76.0219 36.7207 75.8137C13.9492 62.0207 0.234221 37.1932 0 11.1426C0 10.518 0.208197 10.0496 0.754713 9.76328C12.8301 2.97086 26.415 -0.282211 40.0519 0.00406001C40.6504 0.00406001 40.8846 0.550577 40.6504 1.04504C38.7767 4.94873 37.1892 8.9305 35.966 12.9123C35.8359 13.3807 35.5236 13.6149 35.0291 13.6409C27.7422 14.0053 20.6375 15.6709 14.1314 18.3774C14.5998 22.0729 15.4066 25.7164 16.4736 29.2037L16.4475 29.1776ZM41.6394 13.693C41.1969 13.641 40.8846 13.2506 41.0148 12.7821C42.4461 8.6182 44.0857 4.71451 45.9594 1.07107C46.1676 0.62865 46.558 0.472503 47.0525 0.524552C57.3322 1.66963 67.0394 4.92271 75.7056 9.76328C76.2261 10.0496 76.4603 10.518 76.4603 11.1426C76.2781 35.8139 63.9424 59.3922 43.1488 73.6797C42.7584 73.966 42.2379 73.8098 42.0818 73.3414C40.5724 69.2815 39.3492 65.1697 38.4644 61.1879C38.3342 60.6674 38.4644 60.251 38.8807 59.9387C51.4767 50.0233 60.273 35.2153 62.407 18.3774C56.0049 15.7229 49.0564 14.0834 41.6914 13.693H41.6394ZM94.9117 19.0541C94.9117 18.6637 95.172 18.4035 95.5623 18.4035H125.465C125.829 18.4035 126.115 18.7938 125.985 19.1321L123.305 26.5492C123.148 26.9655 122.862 27.1477 122.42 27.1477H104.124V35.1633H119.375C119.739 35.1633 120.025 35.5537 119.895 35.892L117.267 43.1528C117.111 43.5953 116.824 43.7774 116.382 43.7774H104.124V57.2322C104.124 57.6225 103.864 57.8828 103.474 57.8828H95.5623C95.172 57.8828 94.9117 57.6225 94.9117 57.2322V19.028V19.0541ZM135.068 19.002C135.224 18.5856 135.51 18.4035 135.953 18.4035H146.545C146.987 18.4035 147.273 18.5856 147.429 19.002L161.3 57.1801C161.431 57.5184 161.144 57.9088 160.78 57.9088H152.4C151.958 57.9088 151.697 57.7006 151.541 57.2842L148.887 49.5809H133.558L130.904 57.2842C130.774 57.7006 130.487 57.9088 130.045 57.9088H121.769C121.405 57.9088 121.118 57.5184 121.249 57.1801L135.12 19.002H135.068ZM145.92 40.9668L141.209 27.3039L136.499 40.9668H145.946H145.92ZM165.178 19.0541C165.178 18.6637 165.438 18.4035 165.829 18.4035H175.015C175.484 18.4035 175.77 18.5596 176.004 18.976L189.771 42.3721V19.028C189.771 18.6377 190.032 18.3774 190.422 18.3774H198.177C198.568 18.3774 198.828 18.6377 198.828 19.028V57.2322C198.828 57.6225 198.568 57.8828 198.177 57.8828H189.095C188.626 57.8828 188.34 57.7266 188.106 57.3102L174.235 33.7319V57.2322C174.235 57.6225 173.974 57.8828 173.584 57.8828H165.829C165.438 57.8828 165.178 57.6225 165.178 57.2322V19.028V19.0541ZM221.365 49.1645C227.637 49.1645 232.374 44.4281 232.374 38.1561C232.374 31.8842 227.637 27.1477 221.365 27.1477H207.312C206.922 27.1477 206.661 26.8875 206.661 26.4971V19.0541C206.661 18.6637 206.922 18.4035 207.312 18.4035H221.365C232.946 18.4035 241.612 26.8875 241.612 38.1561C241.612 49.4248 232.946 57.9088 221.365 57.9088H207.312C206.922 57.9088 206.661 57.6485 206.661 57.2582V38.7807C206.661 36.3084 207.442 34.3826 208.847 32.9772C210.123 31.702 212.1 30.8692 213.844 30.8692H215.223C215.614 30.8692 215.874 31.1295 215.874 31.5198V49.1385H221.365V49.1645ZM247.286 42.3201V19.028C247.286 18.6377 247.546 18.3774 247.936 18.3774H255.848C256.238 18.3774 256.498 18.6377 256.498 19.028V42.294C256.498 46.7703 259.621 49.8932 264.098 49.8932C268.574 49.8932 271.697 46.7963 271.697 42.294V19.028C271.697 18.6377 271.957 18.3774 272.347 18.3774H280.259C280.649 18.3774 280.91 18.6377 280.91 19.028V42.294C280.91 52.0012 274.065 58.6375 264.098 58.6375C254.13 58.6375 247.286 52.0012 247.286 42.294V42.3201ZM315.418 33.6799C315.809 33.6799 316.069 33.9401 316.069 34.3305V41.6434C316.069 42.0338 315.809 42.294 315.418 42.294H297.956V49.1385H316.485C316.876 49.1385 317.136 49.3987 317.136 49.7891V57.2322C317.136 57.6225 316.876 57.8828 316.485 57.8828H289.394C289.003 57.8828 288.743 57.6225 288.743 57.2322V19.028C288.743 18.6377 289.003 18.3774 289.394 18.3774H316.485C316.876 18.3774 317.136 18.6377 317.136 19.028V26.4711C317.136 26.8614 316.876 27.1217 316.485 27.1217H297.956V33.6539H315.418V33.6799ZM334.078 49.1645H352.295C352.685 49.1645 352.946 49.4248 352.946 49.8151V57.2582C352.946 57.6485 352.685 57.9088 352.295 57.9088H325.516C325.125 57.9088 324.865 57.6485 324.865 57.2582V19.028C324.865 18.6377 325.125 18.3774 325.516 18.3774H333.427C333.818 18.3774 334.078 18.6377 334.078 19.028V49.1385V49.1645Z", fill: "#0078FF" }))));
    };

    var title$2 = "Please verify you are a human";
    var intro$1 = "Access to this page has been denied because we believe you are using automation tools to browse the website.";
    var reasons$1 = {
    	intro: "This may happen as a result of the following:",
    	causes: {
    		blocked: "Javascript is disabled or blocked by an extension (ad blockers for example)",
    		support: "Your browser does not support cookies"
    	},
    	fixes: "Please make sure that Javascript and cookies are enabled on your browser and that you are not blocking them from loading."
    };
    var adblock$1 = {
    	intro: "Using ad blocker (e.g. uBlock Origin, AdBlock, Adblock Plus, etc.)?",
    	fixes: "Please disable your ad blocker temporarily"
    };
    var commonEn = {
    	title: title$2,
    	intro: intro$1,
    	reasons: reasons$1,
    	adblock: adblock$1
    };

    var title$1 = "Verifique se você é humano";
    var intro = "O acesso à esta página foi negado porque acreditamos que você esteja usando ferramentas de automação para navegar no site.";
    var reasons = {
    	intro: "Isso pode acontecer em decorrência do seguinte:",
    	causes: {
    		blocked: "O Javascript está desabilitado ou bloqueado por uma extensão (ad blockers por exemplo)",
    		support: "Seu navegador não suporta cookies"
    	},
    	fixes: "Certifique-se de que o Javascript e os cookies estejam habilitados no seu navegador e que você não os está bloqueando para carregar"
    };
    var adblock = {
    	intro: "Está usando um ad blocker (por exemplo, uBlock Origin, AdBlock, Adblock Plus, etc.)?",
    	fixes: "Desabilite temporariamente o seu ad blocker"
    };
    var commonPt = {
    	title: title$1,
    	intro: intro,
    	reasons: reasons,
    	adblock: adblock
    };

    const localisationConfig = {
        detection: {
            order: ['navigator'],
        },
        interpolation: { escapeValue: false },
        fallbackLng: 'en-US',
        resources: {
            'en-US': {
                translation: commonEn,
            },
            pt: {
                translation: commonPt,
            },
        },
    };

    const withLocalisation = (config, namespace) => (Component) => (...props) => {
        const i18NextInstance = React.useMemo(() => {
            i18next__default["default"].use(LanguageDetector__default["default"]).init(config);
            return i18next__default["default"];
        }, [config]);
        const TranslationWrapper = () => {
            const { t } = reactI18next.useTranslation(namespace);
            return React__default["default"].createElement(Component, Object.assign({ t: t }, props));
        };
        return (React__default["default"].createElement(React__default["default"].Fragment, null,
            React__default["default"].createElement(reactI18next.I18nextProvider, { i18n: i18NextInstance },
                React__default["default"].createElement(TranslationWrapper, null))));
    };

    const css = `#px-modal {
	align-items: center;
	background-color: #2d363bbf;
	display: flex;
	height: 100vh;
	width: 100vw;
	justify-content: center;
	left: 0;
	position: fixed;
	text-align: center;
	top: 0;
	visibility: hidden;
	z-index: 999999;
}
.modal-container {
	height: 100vh;
	width: 100vw;
	display: flex;
	justify-content: center;
	align-items: center;
}
.modal-content {
	background-color: #f0f3f8;
	max-width: 640px;
	padding: 24px;
	width: fit-content;
	height: fit-content;
}
.modal-logo {
	width: auto;
	max-width: 283px;
	margin: 0 auto;
}
.captcha-container {
	display: flex;
	justify-content: center;
}
.modal-title {
	margin-bottom: 12px;
	margin-top: 12px;
	color: #1f375b;
	padding: 16px;
	font-family: ProximaNova, Arial;
	font-weight: normal;
}
.modal-content {
	margin-top: 16px;
}

.modal-paragraph {
	font-family: ProximaNova, Arial;
	line-height: 1.4;
	margin: 12px;
}
@media screen and (min-width: 768px) {
	#px-modal {
		background-color: transparentize(0.25, #2d363b);
	}
	.modal-content {
		border-radius: 4px;
	}
	.content {
		border-radius: 4px;
		padding: 24px;
		background-color: white;
		box-shadow: 0 8px 16px rgba(45, 54, 59, 0.25);
	}
}
`;
    const PxModalElement = ({ t }) => {
        return (React__default["default"].createElement("div", { className: "modal-container" },
            React__default["default"].createElement("div", { className: "modal-content" },
                React__default["default"].createElement("div", { className: "modal-logo" },
                    React__default["default"].createElement(FdLogo, null)),
                React__default["default"].createElement("h2", { className: "modal-title" }, t('title')),
                React__default["default"].createElement("div", { className: "captcha-container", id: "px-captcha" }),
                React__default["default"].createElement("div", { className: "content" },
                    React__default["default"].createElement("p", { className: "modal-paragraph" }, t('intro')),
                    React__default["default"].createElement("p", { className: "modal-paragraph" },
                        React__default["default"].createElement("strong", null, t('reasons.intro'))),
                    React__default["default"].createElement("p", { className: "modal-paragraph" }, t('reasons.causes.blocked')),
                    React__default["default"].createElement("p", { className: "modal-paragraph" }, t('reasons.causes.support')),
                    React__default["default"].createElement("p", { className: "modal-paragraph" }, t('reasons.fixes')),
                    React__default["default"].createElement("p", { className: "modal-paragraph" },
                        React__default["default"].createElement("strong", null, t('adblock.intro'))),
                    React__default["default"].createElement("p", { className: "modal-paragraph" }, t('adblock.fixes'))),
                React__default["default"].createElement("style", { type: "text/css" }, css))));
    };
    const PxModal = withLocalisation(localisationConfig)(PxModalElement);

    class PerimeterxModal extends Modal {
        constructor(stylesheetId) {
            super(stylesheetId);
        }
        /**
         * @public Method to create modal elements
         * with iframe content
         */
        createModal() {
            super.createModal();
            this._modal.id = 'px-modal';
            this._modal.setAttribute('data-perimeterx-modal', '');
            ReactDOM__default["default"].render(React__default["default"].createElement(PxModal, null), document.getElementById('px-modal'));
        }
    }

    function perimeterxHandler(error) {
        const modalWrapperSelector = document.querySelectorAll('[data-perimeterx-modal]');
        if (modalWrapperSelector.length === 0) {
            const pxModal = new PerimeterxModal('px-stylesheet');
            pxModal.open();
        }
        if (modalWrapperSelector.length !== 0) {
            const modalWrapperCurrentStyle = modalWrapperSelector[0].getAttribute('style');
            if (modalWrapperCurrentStyle && modalWrapperCurrentStyle.indexOf('visibility: visible') !== -1) {
                return;
            }
            modalWrapperSelector[0].setAttribute('style', 'visibility: visible');
        }
        const { response: { data }, } = error;
        window['_pxAppId'] = data.appId;
        window['_pxJsClientSrc'] = data.jsClientSrc;
        window['_pxFirstPartyEnabled'] = data.firstPartyEnabled;
        window['_pxVid'] = data.vid || null;
        window['_pxUuid'] = data.uuid;
        window['_pxHostUrl'] = data.hostUrl;
        window['_pxreCaptchaTheme'] = 'dark';
        window['_isPxActive'] = true;
        const script = document.createElement('script');
        script.src = data.blockScript;
        document.getElementsByTagName('head')[0].appendChild(script);
    }

    let HttpService = class HttpService {
        constructor(_configService, _loggerService) {
            this._configService = _configService;
            this._loggerService = _loggerService;
        }
        /**
         * Generic axios GET request method
         * @param {string} urlPart - Request URL
         * @param {object} params - Optional URL params
         * @param {IKeyValuePairs} extraHeaders - Optional extra headers
         * @returns {Promise<any>}
         */
        get(urlPart, params, extraHeaders) {
            return __awaiter(this, void 0, void 0, function* () {
                const url = `${this._configService.baseDomain}${urlPart}${objToQueryString(params)}`;
                const headers = getHeaders(this._configService, extraHeaders);
                return axios__default["default"]
                    .get(url, { headers })
                    .then((result) => {
                    return result.data;
                })
                    .catch((error) => {
                    this._loggerService.error(error);
                    throw error;
                });
            });
        }
        /**
         * Generic axios POST request method
         * @param {string} urlPart - Request URL
         * @param {IKeyValuePairs} body - Request body
         * @param {object} params - Optional URL params
         * @param {IKeyValuePairs} extraHeaders - Optional extra headers
         * @returns {Promise<any>}
         */
        post(urlPart, body, params, extraHeaders) {
            return __awaiter(this, void 0, void 0, function* () {
                const url = `${this._configService.baseDomain}${urlPart}${objToQueryString(params)}`;
                const headers = getHeaders(this._configService, extraHeaders);
                return axios__default["default"]
                    .post(url, body, { headers })
                    .then((result) => result.data)
                    .catch((error) => {
                    var _a, _b, _c, _d, _e;
                    const isPerimeterX = ((_a = error.response) === null || _a === void 0 ? void 0 : _a.status) === 403 && ((_c = (_b = error.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.appId) && ((_e = (_d = error.response) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.blockScript);
                    if (isPerimeterX) {
                        try {
                            perimeterxHandler(error);
                        }
                        catch (pxTransformerError) {
                            this._loggerService.error(pxTransformerError);
                        }
                    }
                    this._loggerService.error(error);
                    throw error;
                });
            });
        }
    };
    HttpService = __decorate([
        tsyringe.singleton(),
        __metadata("design:paramtypes", [ConfigService, LoggerService])
    ], HttpService);

    const prepareResponseData = (serverData, configService) => {
        if (serverData) {
            const sessionStartTimeInMs = new Date(serverData.session_start_time).valueOf();
            const currentTimeInMs = sessionStartTimeInMs + (serverData.session_time_seconds * 1000);
            const currentTimeFormatted = new Date(currentTimeInMs).toLocaleString(configService.locale, { timeZone: configService.timeZone });
            const amountWageredFormatted = numeral__default["default"](serverData.amount_wagered).format('$0,0.00');
            const result = Object.assign({ title: 'Reality Check', defaultMessage: `You have wagered ${amountWageredFormatted} in the last ${serverData.session_time_minutes} minutes`, currentTimeFormatted }, serverData);
            return result;
        }
        return undefined;
    };

    let RealityCheck = class RealityCheck {
        constructor(configService, httpService, loggerService) {
            this.configService = configService;
            this.httpService = httpService;
            this.loggerService = loggerService;
            this.userRcIntervalInS = 15 * 60;
            this.timePassedInS = 0;
            if (!configService.isSet) {
                throw new Error('Config Object has not been set');
            }
        }
        userLoggedIn(userID, userAuthToken) {
            if (!userID || !userAuthToken) {
                this.triggerStopCallback('Unable to start RC. "userID" and "userAuthToken" are required parameters.');
                return;
            }
            if (userID === this.userId && userAuthToken === this.authToken) {
                this.loggerService.log(`Reality Check for userID: ${this.userId} has already been started.`);
                return;
            }
            // Stop the previous timer
            this.stopTimer();
            this.userId = userID;
            this.authToken = userAuthToken;
            this.startRealityCheck();
        }
        userLoggedOff() {
            this.stopRealityCheck('User logged off.');
        }
        onMessageDisplay(callback) {
            this.onDisplayRealityCheckCallback = callback;
        }
        onRealityCheckStop(callback) {
            this.onRealityCheckStopCallback = callback;
        }
        setUserAuthToken(token) {
            this.authToken = token;
        }
        startRealityCheck() {
            return __awaiter(this, void 0, void 0, function* () {
                this.loggerService.log(`Starting Reality Check for UserId: ${this.userId}`);
                yield this.fetchData();
                if (this.dataFromServer) {
                    this.startTimer();
                }
            });
        }
        stopRealityCheck(reason) {
            const msg = `Stopping RC for UserId: ${this.userId}. ${reason}`;
            this.loggerService.log(msg);
            this.triggerStopCallback(msg);
            this.stopTimer();
        }
        fetchData() {
            return __awaiter(this, void 0, void 0, function* () {
                const url = `/users/${this.userId}/reality_check`;
                const authTokenHeader = { 'X-Auth-Token': this.authToken };
                try {
                    const result = yield this.httpService.get(url, undefined, authTokenHeader);
                    if (result) {
                        this.dataFromServer = result;
                        this.userRcIntervalInS = this.dataFromServer.reality_check_interval * 60;
                        // Take into account the session start time
                        // It is possible that the session has started way before RC was notified
                        this.timePassedInS = this.dataFromServer.session_time_seconds % this.userRcIntervalInS;
                    }
                    else {
                        this.stopRealityCheck('API did not return data.');
                    }
                }
                catch (_a) {
                    this.stopRealityCheck('Unable to fetch Reality Check details.');
                }
            });
        }
        startTimer() {
            this.loggerService.log('Starting timer with INTERVAL in seconds -> ' + this.userRcIntervalInS);
            this.timer = setInterval(() => __awaiter(this, void 0, void 0, function* () {
                this.timePassedInS++;
                if (this.timePassedInS === this.userRcIntervalInS) {
                    this.timePassedInS = 0;
                    this.triggerRealityCheckMessage();
                }
            }), 1000);
        }
        stopTimer() {
            clearInterval(this.timer);
            this.userId = undefined;
            this.authToken = undefined;
            this.timePassedInS = 0;
            this.dataFromServer = undefined;
        }
        triggerRealityCheckMessage() {
            return __awaiter(this, void 0, void 0, function* () {
                yield this.fetchData();
                if (this.onDisplayRealityCheckCallback && this.dataFromServer) {
                    try {
                        const rcResult = prepareResponseData(this.dataFromServer, this.configService);
                        this.onDisplayRealityCheckCallback(rcResult);
                    }
                    catch (e) {
                        this.loggerService.log('Unable to process server data.');
                        this.loggerService.log(e);
                    }
                }
            });
        }
        triggerStopCallback(message) {
            if (this.onRealityCheckStopCallback) {
                this.onRealityCheckStopCallback(message);
            }
        }
    };
    RealityCheck = __decorate([
        tsyringe.injectable(),
        __metadata("design:paramtypes", [ConfigService,
            HttpService,
            LoggerService])
    ], RealityCheck);

    /**
     * Decorator to check instance is initialised within the browser
     */
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const BrowserOnly = (message = 'This must only be run within the browser') => (constructor) => {
        if (!isBrowser)
            console.warn('WARNING: ' + message);
    };

    /**
     * Basic storage service to set, get, and delete from localStorage
     */
    let LocalCache = class LocalCache {
        /**
         * Method to set item in localStorage
         * @param {string} key - string to identify within localStorage
         * @param {any} value - value set in localStorage, can include expiry
         * @returns {void}
         */
        setItem(key, value) {
            window.localStorage.setItem(key, toJson(value));
        }
        /**
         * Method to get item from localStorage
         * @param {string} key - string to identify within localStorage
         * @returns {T} - item in localStorage
         */
        getItem(key) {
            const value = window.localStorage.getItem(key);
            return value ? fromJson(value) : null;
        }
        /**
         * Method to remove item from localStorage
         * @param {string} key - string to identify within localStorage
         * @returns {void}
         */
        removeItem(key) {
            window.localStorage.removeItem(key);
        }
    };
    LocalCache = __decorate([
        tsyringe.singleton(),
        BrowserOnly()
    ], LocalCache);

    exports.CallbackActionType = void 0;
    (function (CallbackActionType) {
        CallbackActionType["LOG_EVENT"] = "aw-flows/bridge/to-react/log-event";
        CallbackActionType["USER_INTERACTED"] = "aw-flows/bridge/to-react/user-interacted";
    })(exports.CallbackActionType || (exports.CallbackActionType = {}));
    class AccountSDKConfig extends BaseSDKInitConfig {
        constructor(init) {
            super(init);
            this.environment = 'PROD';
        }
    }
    __decorate([
        required,
        __metadata("design:type", Object)
    ], AccountSDKConfig.prototype, "appDomain", void 0);
    __decorate([
        required,
        __metadata("design:type", String)
    ], AccountSDKConfig.prototype, "clientId", void 0);
    exports.Path = void 0;
    (function (Path) {
        Path["Login"] = "/login";
        Path["Join"] = "/join";
    })(exports.Path || (exports.Path = {}));
    exports.DomainPrefix = void 0;
    (function (DomainPrefix) {
        DomainPrefix["Sportsbook"] = "sportsbook";
        DomainPrefix["Casino"] = "casino";
        DomainPrefix["StardustCasino"] = "stardustcasino";
        DomainPrefix["MoheganSun"] = "mohegansun";
        DomainPrefix["SkilledGames"] = "games";
        DomainPrefix["Racing"] = "racing";
        DomainPrefix["Dfs"] = "www";
        DomainPrefix["StardustCasinoProd"] = "stardustcasino.com";
        DomainPrefix["MoheganSunCasinoProd"] = "mohegansuncasino.com";
        DomainPrefix["SkilledGamesProd"] = "skillgames";
    })(exports.DomainPrefix || (exports.DomainPrefix = {}));
    exports.Domain = void 0;
    (function (Domain) {
        Domain["PROD"] = "fanduel.com";
        Domain["FNDL"] = "fndl.dev";
        Domain["DEVSTACK"] = "devstack-STACK_NAME-web.use1.dev.us.fdbox.net";
    })(exports.Domain || (exports.Domain = {}));

    const first = (arr) => {
        if (!arr.length)
            throw new Error('Missing first element');
        try {
            return arr[0];
        }
        catch (err) {
            throw new Error(err);
        }
    };
    const httpCodeMatch = (statusNum) => (comparison) => {
        return new RegExp(`${statusNum}[0-9][0-9]`).test(String(comparison));
    };
    /**
     * Export common use cases
     */
    const http400Match = httpCodeMatch(4);
    const http500Match = httpCodeMatch(5);
    /**
     *
     * @param obj - obj to map value
     * @returns {Function} - curried function to later pass a value against the obj
     */
    const mapper = (obj) => (value) => {
        return obj[value] || 'UNKNOWN';
    };
    /**
     * @param product product name to map to shorter abbreviation for license api
     */
    const productMap = mapper({
        sportsbook: 'SB',
        casino: 'CASINO',
        skilledGames: 'SG',
        racing: 'RACING',
        dfs: 'DFS',
    });
    /**
     * helper function to replace underscores with spaces
     */
    const replaceUnderscore = replace('_')(' ');

    const parseJwt = (token) => {
        const base64Url = token.split('.')[1];
        const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        const jsonPayload = decodeURIComponent(atob(base64)
            .split('')
            .map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
            .join(''));
        return JSON.parse(jsonPayload);
    };
    const getTokenExpiryTimeMs = (token) => {
        const parsedJwtToken = parseJwt(token);
        const { exp } = parsedJwtToken;
        return exp * 1000;
    };
    const getProtocol = (env) => {
        if (env === undefined)
            return 'http';
        switch (env.toLowerCase()) {
            case 'prod':
            case 'qa':
            case 'dev':
            case 'cert':
            case 'dge-cert':
                return 'https';
            default:
                return 'http';
        }
    };
    const getHost = (env, appDomain) => {
        var _a;
        if (process.env.NODE_ENV !== 'production' && process.env.REACT_APP_DOMAIN_OVERRIDE) {
            return process.env.REACT_APP_DOMAIN_OVERRIDE;
        }
        const region = (_a = appDomain.region) === null || _a === void 0 ? void 0 : _a.toLowerCase();
        const domain = getDomain(env, appDomain);
        if (region) {
            return `${region}.${domain}`;
        }
        else {
            return `${domain}`;
        }
    };
    const localhostCheck = (env) => () => {
        /** http://localhost:3001 -> localhost:3001 */
        const localhostHostReg = /localhost:([0-9]+)$/g;
        return first(localhostHostReg.exec(env));
    };
    const getAccountHost = (env, appDomain) => {
        var _a;
        if (process.env.REACT_APP_DOMAIN_OVERRIDE) {
            return `account.${process.env.REACT_APP_DOMAIN_OVERRIDE}`;
        }
        /** check for localhost development */
        if (new RegExp('localhost').test(env)) {
            const [localhostDomain, err] = tryCatch(localhostCheck(env));
            if (err) {
                return null;
            }
            return localhostDomain;
        }
        const product = appDomain.product.toLowerCase();
        const region = (_a = appDomain.region) === null || _a === void 0 ? void 0 : _a.toLowerCase();
        const domain = getDomain(env, appDomain);
        if (product === 'dfs') {
            return domain;
        }
        if (product === 'skilledgames' || product === 'racing') {
            return `account.${domain}`;
        }
        if (region) {
            return `account.${region}.${domain}`;
        }
        else {
            return `account.${domain}`;
        }
    };
    const getDomain = (environment, appDomain) => {
        const regex = /STACK_NAME/;
        const isDFS = appDomain.product.toLowerCase() === 'dfs';
        const env = environment.toLowerCase();
        switch (env) {
            case 'prod':
                if (appDomain.product === 'casino') {
                    const brand = appDomain.brand.toLowerCase();
                    if (brand === 'mohegansun') {
                        return `${getDomainPrefix(env, appDomain)}`;
                    }
                    if (brand === 'stardust') {
                        return `${getDomainPrefix(env, appDomain)}`;
                    }
                }
                return `${getDomainPrefix(env, appDomain)}.${exports.Domain.PROD}`;
            case 'cert':
            case 'dge-cert':
            case 'qa':
            case 'dev':
                return `${getDomainPrefix(env, appDomain)}.${env}.${exports.Domain.FNDL}`;
            default:
                if (isDFS) {
                    return `${exports.Domain.DEVSTACK.replace(regex, environment)}`;
                }
                return `${getDomainPrefix(environment, appDomain)}.${exports.Domain.DEVSTACK.replace(regex, environment)}`;
        }
    };
    const getDomainPrefix = (environment, appDomain) => {
        const env = environment.toLowerCase();
        const product = appDomain.product.toLowerCase();
        const isProd = env.toLowerCase() === 'prod';
        const casinoBrand = appDomain.product === 'casino' ? appDomain.brand : 'FanDuel';
        switch (product) {
            case 'sportsbook':
            case 'sb':
                return exports.DomainPrefix.Sportsbook;
            case 'casino':
                return getCasinoDomainPrefix(env, casinoBrand);
            case 'dfs':
                switch (env) {
                    case 'prod':
                    case 'qa':
                    case 'dev':
                    case 'dge-cert':
                    case 'cert':
                        return exports.DomainPrefix.Dfs;
                    default:
                        return;
                }
            case 'racing':
                return exports.DomainPrefix.Racing;
            case 'skilledgames':
            case 'sg':
                if (isProd) {
                    return exports.DomainPrefix.SkilledGamesProd;
                }
                return exports.DomainPrefix.SkilledGames;
            default:
                return exports.DomainPrefix.Dfs;
        }
    };
    const getCasinoDomainPrefix = (env, brand) => {
        const isProd = env.toLowerCase() === 'prod';
        switch (brand.toLowerCase()) {
            case 'fanduel':
                return exports.DomainPrefix.Casino;
            case 'stardust':
                if (isProd) {
                    return exports.DomainPrefix.StardustCasinoProd;
                }
                return exports.DomainPrefix.StardustCasino;
            case 'mohegansun':
                if (isProd) {
                    return exports.DomainPrefix.MoheganSunCasinoProd;
                }
                return exports.DomainPrefix.MoheganSun;
        }
    };

    class Token {
        // todo refactor this so theres no potential of lingering old now value
        //private now = Date.now();
        // private now = new Date('2022-04-05T20:13:50Z').getTime();
        constructor(jwt) {
            this.jwt = jwt;
            this.expiryBuffer = 5000;
            this.jwt = jwt;
            this.tokenExpiryDateMs = getTokenExpiryTimeMs(jwt);
        }
        get now() {
            if (process.env.NODE_ENV !== 'production' && process.env.REACT_APP_DISTORT_TOKEN_NOW_FOR_PX === 'true') {
                return new Date(this.tokenExpiryDateMs - this.expiryBuffer);
            }
            return Date.now();
        }
        /**
         * used to check login token expiry
         * @returns boolean
         */
        isExpired() {
            return this.now > this.tokenExpiryDateMs;
        }
        /**
         * used to check auth token expiry (5s buffer)
         * @returns boolean
         */
        isOrNearExpired() {
            return this.now >= this.tokenExpiryDateMs - this.expiryBuffer;
        }
    }

    let MutableSession = class MutableSession {
        constructor({ loginToken, authToken, sessionId, userId }) {
            this.authToken = authToken || this.authToken;
            this.loginToken = loginToken || this.loginToken;
            this.sessionId = sessionId || this.sessionId;
            this.userId = userId || this.userId;
        }
        isValid() {
            const { isValid } = RequiredValidator.validate(this);
            return isValid;
        }
    };
    __decorate([
        required,
        __metadata("design:type", String)
    ], MutableSession.prototype, "loginToken", void 0);
    __decorate([
        required,
        __metadata("design:type", String)
    ], MutableSession.prototype, "authToken", void 0);
    __decorate([
        required,
        __metadata("design:type", String)
    ], MutableSession.prototype, "sessionId", void 0);
    __decorate([
        required,
        __metadata("design:type", String)
    ], MutableSession.prototype, "userId", void 0);
    MutableSession = __decorate([
        tsyringe.singleton(),
        __metadata("design:paramtypes", [Object])
    ], MutableSession);

    var SessionCookie;
    (function (SessionCookie) {
        SessionCookie["loginToken"] = "X-Login-Token";
        SessionCookie["authToken"] = "X-Auth-Token";
        SessionCookie["sessionId"] = "Session-ID";
    })(SessionCookie || (SessionCookie = {}));

    let Session = class Session {
        constructor() {
            this.sessionData = null;
            this.authToken = null;
            this.loginToken = null;
            this.mutableSession = null;
        }
        get session() {
            return {
                sessionData: this.sessionData,
                authToken: this.authToken,
                loginToken: this.loginToken,
            };
        }
        getSession() {
            const emptySession = {
                sessionData: null,
                authToken: null,
                loginToken: null,
            };
            if (RequiredValidator.validate(this).isValid) {
                return this.session;
            }
            else {
                const { authToken, loginToken, sessionId, userId } = this.getSessionFromCache() || {};
                if (authToken && loginToken && sessionId && userId) {
                    this.setSessionInfo({ authToken, loginToken, sessionId, userId });
                    return this.session;
                }
            }
            return emptySession;
        }
        setSessionInfo(data) {
            if (new MutableSession(data).isValid()) {
                const { authToken, loginToken, sessionId, userId } = data;
                this.sessionData = {
                    authToken,
                    sessionId,
                    userId,
                };
                this.authToken = new Token(authToken);
                this.loginToken = new Token(loginToken);
            }
            else {
                throw new Error('session invalid');
            }
        }
        setMutableSessionInfo(data) {
            this.mutableSession = new MutableSession(Object.assign(Object.assign({}, this.mutableSession), data));
            if (this.mutableSession.isValid()) {
                this.setSessionAndCache(this.mutableSession);
                this.mutableSession = null;
            }
        }
        setSessionAndCache(data) {
            this.setSessionInfo(data);
            this.setSessionCache(data);
        }
        clearSession(env, domain) {
            this.sessionData = null;
            this.authToken = null;
            this.loginToken = null;
            this.clearSessionCache();
            this.clearSessionCookies(env, domain);
        }
        getSessionFromCache() {
            const authToken = localStorage.getItem(exports.BrowserStorageKeys.Auth);
            const loginToken = localStorage.getItem(exports.BrowserStorageKeys.Login);
            const sessionId = localStorage.getItem(exports.BrowserStorageKeys.SessionId);
            const userId = localStorage.getItem(exports.BrowserStorageKeys.UserId);
            return { authToken, loginToken, userId, sessionId };
        }
        clearSessionCache() {
            localStorage.removeItem(exports.BrowserStorageKeys.Auth);
            localStorage.removeItem(exports.BrowserStorageKeys.Login);
            localStorage.removeItem(exports.BrowserStorageKeys.SessionId);
            localStorage.removeItem(exports.BrowserStorageKeys.UserId);
        }
        clearSessionCookies(env, domain) {
            const cookieDomain = getHost(env, domain);
            Object.values(SessionCookie).forEach((val) => Cookies__default["default"].remove(val, { domain: cookieDomain }));
        }
        setSessionCache(data) {
            if (new MutableSession(data).isValid()) {
                const { authToken, loginToken, sessionId, userId } = data;
                localStorage.setItem(exports.BrowserStorageKeys.Auth, authToken);
                localStorage.setItem(exports.BrowserStorageKeys.Login, loginToken);
                localStorage.setItem(exports.BrowserStorageKeys.SessionId, sessionId);
                localStorage.setItem(exports.BrowserStorageKeys.UserId, userId);
            }
        }
    };
    __decorate([
        required,
        __metadata("design:type", Object)
    ], Session.prototype, "sessionData", void 0);
    __decorate([
        required,
        __metadata("design:type", Object)
    ], Session.prototype, "authToken", void 0);
    __decorate([
        required,
        __metadata("design:type", Object)
    ], Session.prototype, "loginToken", void 0);
    Session = __decorate([
        tsyringe.singleton(),
        tsyringe.injectable()
    ], Session);

    let SessionApi = class SessionApi extends HttpService {
        constructor(configService, loggerService, session) {
            super(configService, loggerService);
            this.session = session;
            this.sessionUrl = '/sessions';
        }
        loginWithToken() {
            return __awaiter(this, void 0, void 0, function* () {
                return yield this.post(this.sessionUrl, { login_token: this.session.loginToken.jwt });
            });
        }
    };
    SessionApi = __decorate([
        tsyringe.singleton(),
        __metadata("design:paramtypes", [ConfigService, LoggerService, Session])
    ], SessionApi);

    let LoginModal = class LoginModal {
        constructor(configService, localCache) {
            this.configService = configService;
            this.localCache = localCache;
            this.styleSheetId = 'login-modal';
            /**
             * @private Callback method passed to event listener for closing the modal when backdrop is clicked
             */
            this.closeOnWindowClick = (e) => {
                if (e.target == this._modal) {
                    this.close();
                }
            };
            /**
             * @private Callback method passed to event listener to close modal when Esc key is pressed
             */
            this.closeOnEsc = (e) => {
                if (e.key === 'Esc' || e.key === 'Escape') {
                    this.close();
                }
            };
            /**
             * @private Callback method passed to event listener to close modal when Done is clicked
             */
            this.closeOnDoneClick = (e) => {
                e.preventDefault();
                this.close();
            };
        }
        /**
         * @public Method to open the login modal
         * If the modal doesn't exist, it will create it
         * @param {string} path - url path passed to the iframe src
         */
        open(path, onClose) {
            if (!this._modal) {
                this.createModal(path);
            }
            this._modal.setAttribute('aria-hidden', 'false');
            this._modal.removeAttribute('hidden');
            this._modal.style.display = 'block';
            this.onClose = onClose;
        }
        /**
         * @public Method to close the modal
         */
        close() {
            var _a;
            if (!this._modal)
                return;
            this._modal = null;
            const modalElement = document.getElementById('modal');
            if (modalElement) {
                this.removeModal(modalElement);
            }
            this.removeEventListeners();
            (_a = this.onClose) === null || _a === void 0 ? void 0 : _a.call(this);
        }
        addEventListeners(btnElement) {
            if (btnElement !== undefined) {
                btnElement.addEventListener('click', this.closeOnDoneClick);
            }
            document.addEventListener('click', this.closeOnWindowClick);
            document.addEventListener('keydown', this.closeOnEsc);
        }
        removeEventListeners() {
            document.removeEventListener('click', this.closeOnWindowClick);
            document.removeEventListener('keydown', this.closeOnEsc);
            document.removeEventListener('click', this.closeOnDoneClick);
        }
        /**
         * @private Method to remove the modal and styles from the dom
         * @returns {void}
         */
        removeModal(element) {
            this.removeElement(element);
            this.removeStyleSheet(this.styleSheetId);
        }
        /**
         * @private Method to remove an element from the DOM
         * @param element to be removed
         */
        removeElement(element) {
            element.parentNode.removeChild(element);
        }
        /**
         * @private Method to remove stylesheet from the dom with the id
         * @param {id} stylesheet id
         */
        removeStyleSheet(id) {
            const styles = document.getElementById(id);
            if (styles !== null) {
                styles.disabled = true;
                styles.parentNode.removeChild(styles);
            }
        }
        /**
         * @private Method to create modal elements
         * with iframe content
         */
        createModal(path = exports.Path.Login) {
            // remove previous event listeners
            this.removeEventListeners();
            this._modal = document.createElement('div');
            this._modal.id = 'modal';
            this._modal.setAttribute('aria-hidden', 'true');
            this._modal.setAttribute('hidden', 'true');
            this._modal.setAttribute('role', 'dialog');
            this._modal.setAttribute('aria-modal', 'true');
            const content = document.createElement('div');
            content.id = 'modal-content';
            this._modal.appendChild(content);
            const header = document.createElement('div');
            header.id = 'modal-header';
            content.appendChild(header);
            const h2 = document.createElement('h2');
            h2.innerText = path === exports.Path.Login ? 'Log In' : 'Sign Up';
            header.appendChild(h2);
            const closeBtn = document.createElement('button');
            closeBtn.id = 'close-btn';
            closeBtn.innerText = 'Done';
            header.appendChild(closeBtn);
            const iframe = document.createElement('iframe');
            iframe.id = 'modal-iframe';
            iframe.src = this.getURL(path);
            content.appendChild(iframe);
            const style = document.createElement('style');
            style.id = this.styleSheetId;
            style.innerHTML = `
		#modal {
			display: none;
			position: fixed;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
			z-index: 1000;
			overflow: auto;
			background-color: rgb(21 42 71 / 60%);
		}
		#modal-content {
			position: absolute;
    	top: 50%;
    	left: 50%;
    	transform: translate(-50%, -50%);
    	width: 100%;
			background-color: #fff;
			border-radius: 4px;
		}
		@media screen and (min-width: 768px) {
			#modal-content {
				width: 80%;
			}
		}
		#modal-iframe {
			position: relative;
    	width: 100%;
			height: 85vh;
			border: none;
			vertical-align: middle;
			border-radius: 0 0 4px 4px;
		}
		#modal-header {
			display: flex;
			flex-direction: row;
			justify-content: center;
			padding: 1rem;
			background-color: #1F375B;
			color: #fff;
			border-radius: 4px 4px 0 0;
		}

		h2 {
			margin: 0;
			font-size: 1rem;
    	font-weight: bold;
		}

		#close-btn {
    	display: inline-block;
    	border: none;
    	margin: 0;
    	text-decoration: none;
    	cursor: pointer;
    	text-align: center;
    	-webkit-appearance: none;
    	-moz-appearance: none;
			background: none;
			color: #fff;
    	font-size: 1rem;
    	font-weight: bold;
    	position: absolute;
    	right: 0;
    	margin-right: 0.5rem;
		}
		`;
            document.head.appendChild(style);
            document.body.appendChild(this._modal);
            this.addEventListeners(closeBtn);
        }
        /**
         * @private Method to build URL based on the appDomain and environment.
         * This method will also store the url in local cache
         */
        getURL(path = exports.Path.Login) {
            const domain = this.configService.appDomain;
            const env = this.configService.environment;
            const protocol = getProtocol(env);
            const host = getAccountHost(env, domain);
            const url = `${protocol}://${host}${path}`;
            this.localCache.setItem(exports.BrowserStorageKeys.LoginUrl, url.replace(/\/login|\/join/i, ''));
            return url;
        }
    };
    LoginModal = __decorate([
        tsyringe.singleton(),
        __metadata("design:paramtypes", [ConfigService, LocalCache])
    ], LoginModal);

    const flowsPrefix = '[Flows SDK]';
    const flowsErrorMsg = (functionName) => (msg) => `${flowsPrefix}: [${functionName}]: ${msg}`;

    const sessionChangedErrorMsg = flowsErrorMsg('sessionChange bridge method');
    const sessionChangedWrongArgument = sessionChangedErrorMsg `Argument should be stringified object`;
    const setUserDataErrorMsg = flowsErrorMsg('setUserData bridgeMethod');
    const setUserDataWrongArgument = setUserDataErrorMsg `Argument should be stringified object`;

    class SessionChange {
        constructor(sessionInfo) {
            try {
                this.sessionInfo = JSON.parse(sessionInfo);
            }
            catch (_a) {
                throw new Error(sessionChangedWrongArgument);
            }
            this.id = this.sessionInfo.id;
            this.session_id = this.sessionInfo.session_id;
            this.login_token = this.sessionInfo.login_token;
            const validationResult = RequiredValidator.validate(this);
            if (!validationResult.isValid) {
                const errorMsg = validationResult.errorMessages.map((err) => sessionChangedErrorMsg(err));
                throw new Error(errorMsg.join('\n'));
            }
        }
    }
    __decorate([
        required,
        __metadata("design:type", String)
    ], SessionChange.prototype, "id", void 0);
    __decorate([
        required,
        __metadata("design:type", String)
    ], SessionChange.prototype, "session_id", void 0);
    __decorate([
        required,
        __metadata("design:type", String)
    ], SessionChange.prototype, "login_token", void 0);

    class UserData {
        constructor(userInfo) {
            try {
                this.userInfo = JSON.parse(userInfo);
            }
            catch (_a) {
                throw new Error(setUserDataWrongArgument);
            }
            this.userId = this.userInfo.userId;
            const validationResult = RequiredValidator.validate(this);
            if (!validationResult.isValid) {
                throw new Error(setUserDataErrorMsg(validationResult.errorMessages));
            }
        }
    }
    __decorate([
        required,
        __metadata("design:type", String)
    ], UserData.prototype, "userId", void 0);

    let SessionBridgeMethods = class SessionBridgeMethods {
        constructor(session) {
            this.session = session;
        }
        sessionChanged(sessionInfo) {
            const _sessionInfo = new SessionChange(sessionInfo);
            const parsedSession = {
                authToken: _sessionInfo.id,
                sessionId: _sessionInfo.session_id,
                loginToken: _sessionInfo.login_token,
            };
            this.session.setMutableSessionInfo(parsedSession);
        }
        setUserData(userInfo) {
            const _userInfo = new UserData(userInfo);
            const parsedData = {
                userId: _userInfo.userId,
            };
            this.session.setMutableSessionInfo(parsedData);
        }
    };
    SessionBridgeMethods = __decorate([
        tsyringe.injectable(),
        __metadata("design:paramtypes", [Session])
    ], SessionBridgeMethods);

    /** login flow pages */
    const LoginFlowPages = ['login', 'join', 'account.setUpMfa', 'accept-terms', 'verification'];
    /** account pages */
    const AccountPages = ['account', 'externalReferrerOrHome', 'close', 'contests.discover'];

    const readOnlyIncludes = (arr) => (value) => {
        return arr.includes(value);
    };
    /**
     * helper functions to check the navigation
     */
    const onLoginPage = readOnlyIncludes(LoginFlowPages);
    const notLoginPage = readOnlyIncludes(AccountPages);

    let LoginFlowHandler = class LoginFlowHandler {
        constructor() {
            this.prevPageIsLogin = false;
        }
        /**
         *
         * @param page current page from within the iframe/framed page
         */
        loginFlowComplete(pageId) {
            /**
             * Check the current page is a login flow page
             */
            if (onLoginPage(pageId)) {
                this.setPrevPageAsLogin(true);
                return false;
            }
            /**
             * Not on login state -> check the user has navigated from login to another page
             */
            if (notLoginPage(pageId) && this.prevPageIsLogin) {
                this.setPrevPageAsLogin(false);
                return true;
            }
            /** default to false */
            return false;
        }
        /**
         *
         * @param inLoginFlow boolean to toggle the login flow state
         */
        setPrevPageAsLogin(pageIsLogin) {
            this.prevPageIsLogin = pageIsLogin;
        }
    };
    LoginFlowHandler = __decorate([
        tsyringe.injectable()
    ], LoginFlowHandler);

    let BridgeMethods = class BridgeMethods {
        constructor(sessionBridgeMethods, loginModal, loginFlowHandler) {
            this.sessionBridgeMethods = sessionBridgeMethods;
            this.loginModal = loginModal;
            this.loginFlowHandler = loginFlowHandler;
        }
        sessionChanged(sessionJson) {
            this.sessionBridgeMethods.sessionChanged(sessionJson);
        }
        setUserData(userDataJson) {
            this.sessionBridgeMethods.setUserData(userDataJson);
        }
        loginFlowCompleted(success) {
            if (success)
                this.loginModal.close();
        }
        /**
         * @public Method to run everytime the child application navigates within the iframe
         * @param pageId
         */
        internalNavigation(pageId) {
            const loginComplete = this.loginFlowHandler.loginFlowComplete(pageId);
            this.loginFlowCompleted(loginComplete);
        }
    };
    BridgeMethods = __decorate([
        tsyringe.injectable(),
        __metadata("design:paramtypes", [SessionBridgeMethods,
            LoginModal,
            LoginFlowHandler])
    ], BridgeMethods);

    exports.Account = class Account {
        constructor(configService, sessionApi, session, loginModal, brigdeMethods, localCache) {
            this.configService = configService;
            this.sessionApi = sessionApi;
            this.session = session;
            this.loginModal = loginModal;
            this.brigdeMethods = brigdeMethods;
            this.localCache = localCache;
            this.callbackReference = null;
            this.pendingSessionPromise = null;
            window.addEventListener('message', (e) => this.handleBridgeMethodMessage(e));
        }
        setConfig(config) {
            return new Promise((resolve, reject) => {
                try {
                    const parsedConfig = new AccountSDKConfig();
                    Object.assign(parsedConfig, config);
                    this.configService.setConfig(parsedConfig);
                    resolve();
                }
                catch (err) {
                    reject(err);
                }
            });
        }
        /**
         * - if session already exists but auth token is expired it will make an api call to sessions for a new token
         * - if session exists but auth and login token are both expired it will initiate login
         * @param hint if 'ForceNew' or 'NewUser' the function will clear existing session and initiate login
         * @returns SessionData if session already exists and auth token is not expired
         * @throws error if config not set
         */
        getSession(hint = 'None') {
            var _a;
            return __awaiter(this, void 0, void 0, function* () {
                if (!this.configService.isSet) {
                    const errorMsg = flowsErrorMsg('getSession') `CONFIG NOT SET`;
                    return Promise.reject(new Error(errorMsg));
                }
                switch (hint) {
                    case 'ForceNew':
                        this.clearSession();
                        return this.initiateLoginFlow(exports.Path.Login);
                    case 'NewUser':
                        this.clearSession();
                        return this.initiateLoginFlow(exports.Path.Join);
                }
                if (this.pendingSessionPromise) {
                    return this.pendingSessionPromise;
                }
                const session = this.session.getSession();
                if (session.sessionData !== null && !((_a = session.authToken) === null || _a === void 0 ? void 0 : _a.isOrNearExpired())) {
                    return Promise.resolve(this.session.sessionData);
                }
                else if (session.loginToken !== null) {
                    return this.initiateSessionRefresh();
                }
                else {
                    return this.initiateLoginFlow();
                }
            });
        }
        clearSession() {
            const domain = this.configService.appDomain;
            const env = this.configService.environment;
            this.session.clearSession(env, domain);
        }
        setCallback(callback) {
            this.callbackReference = callback;
        }
        /**
         * called when auth token is expired
         * if no session data returned or api call fails it will redirect to login
         * @returns Session data if api call returns session info
         */
        initiateSessionRefresh() {
            return __awaiter(this, void 0, void 0, function* () {
                this.pendingSessionPromise = this.sessionApi
                    .loginWithToken()
                    .then((data) => {
                    var _a, _b;
                    if (((_a = data === null || data === void 0 ? void 0 : data.sessions) === null || _a === void 0 ? void 0 : _a.length) > 0 && ((_b = data === null || data === void 0 ? void 0 : data.users) === null || _b === void 0 ? void 0 : _b.length) > 0) {
                        const parsedData = {
                            authToken: data.sessions[0].id,
                            sessionId: data.sessions[0].session_id,
                            userId: data.users[0].id,
                            loginToken: data.sessions[0].login_token,
                        };
                        this.session.setSessionAndCache(parsedData);
                        this.pendingSessionPromise = null;
                        return this.session.sessionData;
                    }
                    else {
                        return this.initiateLoginFlow();
                    }
                })
                    .catch((err) => {
                    var _a, _b, _c, _d, _e;
                    const isPerimeterX = ((_a = err.response) === null || _a === void 0 ? void 0 : _a.status) === 403 && ((_c = (_b = err.response) === null || _b === void 0 ? void 0 : _b.data) === null || _c === void 0 ? void 0 : _c.appId) && ((_e = (_d = err.response) === null || _d === void 0 ? void 0 : _d.data) === null || _e === void 0 ? void 0 : _e.blockScript);
                    if (!isPerimeterX) {
                        return this.initiateLoginFlow();
                    }
                });
                return this.pendingSessionPromise;
            });
        }
        /**
         * Shows modal with Login page or Join form for new users
         */
        initiateLoginFlow(path) {
            this.pendingSessionPromise = new Promise((resolve, reject) => {
                this.deferredPromiseExecutor = { resolve, reject };
            });
            const onClose = () => {
                const sessionData = this.session.sessionData;
                if (sessionData) {
                    this.deferredPromiseExecutor.resolve(sessionData);
                }
                else {
                    this.deferredPromiseExecutor.reject('Error: failed to get session');
                }
            };
            this.loginModal.open(path, onClose);
            this.pendingSessionPromise.finally(() => {
                this.pendingSessionPromise = null;
            });
            return this.pendingSessionPromise;
        }
        /**
         * @private Method to listen when data provided in bridgeMethods
         */
        handleBridgeMethodMessage(event) {
            var _a;
            const url = this.localCache.getItem(exports.BrowserStorageKeys.LoginUrl) || '';
            const trustedOrigins = [url];
            if (process.env.NODE_ENV !== 'production' && process.env.REACT_APP_TRUSTED_ORIGINS) {
                trustedOrigins.push(...JSON.parse(process.env.REACT_APP_TRUSTED_ORIGINS));
            }
            const { data, origin, isTrusted } = event;
            if (typeof data !== 'string') {
                return;
            }
            if (!isTrusted || !trustedOrigins.includes(origin))
                return;
            let msg = {};
            try {
                msg = JSON.parse(data);
            }
            catch (err) {
                return;
            }
            if ((_a = msg.meta) === null || _a === void 0 ? void 0 : _a.type) {
                switch (msg.meta.type) {
                    case 'userInteracted': {
                        const userInteractedAction = {
                            type: exports.CallbackActionType.USER_INTERACTED,
                            payload: msg,
                        };
                        this.callbackReference(userInteractedAction);
                        break;
                    }
                    case 'log': {
                        const logEventAction = {
                            type: exports.CallbackActionType.LOG_EVENT,
                            payload: {
                                eventName: msg.eventName,
                                data: msg.data,
                                vendorTag: msg.vendorTag,
                            },
                        };
                        this.callbackReference(logEventAction);
                        break;
                    }
                }
            }
            if (msg.success) {
                this.brigdeMethods.loginFlowCompleted(msg.success);
            }
            if (msg.userId) {
                this.brigdeMethods.setUserData(data);
            }
            if (msg.id) {
                this.brigdeMethods.sessionChanged(data);
            }
            if (msg.pageId) {
                this.brigdeMethods.internalNavigation(msg.pageId);
            }
        }
    };
    exports.Account = __decorate([
        tsyringe.injectable(),
        __metadata("design:paramtypes", [ConfigService,
            SessionApi,
            Session,
            LoginModal,
            BridgeMethods,
            LocalCache])
    ], exports.Account);

    const title = 'fd-account';
    const AccountHomeView = () => {
        const configService = tsyringe.container.resolve(ConfigService);
        const fetchUrl = (appDomain, environment) => {
            const path = 'account';
            if (!appDomain || !environment) {
                throw new Error('config not set, setConfig must be called before render of AccountHomeView');
            }
            const protocol = getProtocol(environment);
            const host = getAccountHost(environment, appDomain);
            const url = `${protocol}://${host}/${path}`;
            return url;
        };
        const url = React__default["default"].useMemo(() => {
            try {
                return fetchUrl(configService.appDomain, configService.environment);
            }
            catch (err) {
                console.log(err);
            }
        }, [configService.appDomain, configService.environment]);
        return React__default["default"].createElement(React__default["default"].Fragment, null, url && React__default["default"].createElement("iframe", { title: title, style: { width: '100%', height: '100%' }, src: url }));
    };

    var License$1;
    (function (License) {
        License["License"] = "geoComplyLicense";
        License["WrongProductError"] = "Wrong Product";
        License["WrongStateError"] = "Wrong State";
        License["Invalid"] = "Invalid License";
    })(License$1 || (License$1 = {}));

    /**
     * Error class thrown when license does not exist in cache
     */
    class MissingLicenseError extends BaseError {
        constructor(message = 'License not in cache') {
            super(message);
        }
    }
    /**
     * Error class thrown when generic error occurs
     */
    class InvalidLicenseError extends BaseError {
        constructor(reason, license) {
            super(reason);
            this.license = license;
        }
    }

    /**
     * LocalStorage methods for the GeoComply license to be cached
     */
    let LicenseCache = class LicenseCache extends LocalCache {
        constructor(configSerivce) {
            super();
            this.configSerivce = configSerivce;
        }
        /**
         * @public Method to set new license data in localstorage
         * @param {ILicenseData} licenseData
         * @returns {void}
         */
        setLicense(licenseData) {
            this.setItem(this.licenseKeyBuilder, licenseData);
        }
        /**
         * @public Method to get license from cache if license is still valid
         * @returns {string} license
         * @param todaysDate - defualt todays today (passed as param for testing)
         * @throws {MissingLicenseError} when license does not exist in localstorage
         * @throws error from isValid method when fails
         */
        getLicenseFromCache(todaysDate = new Date()) {
            const licenseData = this.getLicense();
            if (!licenseData) {
                throw new MissingLicenseError();
            }
            try {
                if (this.isValid(licenseData, todaysDate)) {
                    return licenseData.license;
                }
            }
            catch (err) {
                throw err;
            }
        }
        /**
         * @private Method to get the license from localstorage
         * @returns {ILicenseData | null}
         */
        getLicense() {
            const license = this.getItem(this.licenseKeyBuilder);
            return license;
        }
        /**
         * @public Method to remove license from localstorage
         * @return {void} - inverse boolean value of getter
         */
        removeLicense() {
            this.removeItem(this.licenseKeyBuilder);
        }
        /**
         * @private Method to check whether license in localstorage is valid
         * To be valid it must pass three conditions:
         * 1. License cached is for the consumer product
         * 2. License cached is for the correct state the consumer app operates within
         * 3. License cached expiry date has not expired
         * @remarks any failure removes license from storage & throws error
         * @param {ILicenseData} licenseData - licenseDate to compare
         * @returns {boolean}
         * @throws {InvalidLicenseError} when license is invalid
         */
        isValid(licenseData, todaysDate = new Date()) {
            try {
                const { appDomain: { product, region }, } = this.configSerivce;
                /**
                 * Product mapper is used as the product passed in config is full name 'sportsbook' -> returned from api is shortened: SB
                 */
                const licenseForWrongProduct = licenseData.product !== productMap(product);
                const licenseForWrongState = licenseData.state !== region;
                const licenseHasExpired = todaysDate.getTime() >= toDate(licenseData.expiry).getTime();
                if (licenseForWrongProduct || licenseForWrongState || licenseHasExpired) {
                    throw new InvalidLicenseError(License$1.Invalid, licenseData.license);
                }
                return true;
            }
            catch (err) {
                throw err;
            }
        }
        /**
         * @public Method to get the key for license made for product & region
         * Each license is cached based on product and state to reduce license call to the api
         * format is: geoComplyLicense-<state>-<product>
         */
        get licenseKeyBuilder() {
            const { product: productConfig, region: regionConfig } = this.configSerivce.appDomain;
            const productName = productMap(productConfig).toLowerCase();
            const state = regionConfig.toLowerCase();
            return `${License$1.License}-${state}-${productName}`;
        }
    };
    LicenseCache = __decorate([
        tsyringe.singleton(),
        __metadata("design:paramtypes", [ConfigService])
    ], LicenseCache);

    var License;
    (function (License) {
        License["Route"] = "/geocomply/license";
    })(License || (License = {}));

    class MaxRetryError extends Error {
        constructor(retryAttempts) {
            const message = `Number of retries exceeded, ${retryAttempts} attempts made`;
            super(message);
        }
    }
    /**
     * Promise delay method
     */
    const delay = (ms) => {
        return new Promise((res) => setTimeout(res, ms));
    };
    /**
     * Class method decorator to retry async operation
     */
    function canRetry({ maxRetries = 0, retryErrors = [], timeoutDuration = 0 }) {
        return function (target, propertyKey, descriptor) {
            const method = descriptor.value;
            let OriginalErrorThrown;
            descriptor.value = function (...args) {
                return __awaiter(this, void 0, void 0, function* () {
                    function retry(retriesLeft) {
                        return __awaiter(this, void 0, void 0, function* () {
                            try {
                                /**
                                 * TO STOP INFINTE LOOP - DO NOT REMOVE
                                 */
                                if (!retriesLeft) {
                                    throw new MaxRetryError(maxRetries);
                                }
                                return yield method.apply(this, args);
                            }
                            catch (err) {
                                if (err instanceof MaxRetryError) {
                                    throw new OriginalErrorThrown();
                                }
                                /**
                                 * Check for retry instances
                                 */
                                for (const retryError of retryErrors) {
                                    if (err instanceof retryError) {
                                        /**
                                         * keep ref to original error thrown in method to be thrown if max retries are met
                                         */
                                        OriginalErrorThrown = retryError;
                                        if (timeoutDuration) {
                                            return delay(timeoutDuration).then(() => {
                                                return retry.apply(this, [retriesLeft - 1, args]);
                                            });
                                        }
                                        return retry.apply(this, [retriesLeft - 1, args]);
                                    }
                                }
                                throw err;
                            }
                        });
                    }
                    try {
                        const result = yield retry.apply(this, [maxRetries, args]);
                        return result;
                    }
                    catch (err) {
                        throw err;
                    }
                });
            };
        };
    }

    let LicenseAPI = class LicenseAPI extends HttpService {
        constructor(configService, loggerService) {
            super(configService, loggerService);
            this.configService = configService;
        }
        /**
         * Method to get current license for certain product & state
         * @remarks It can retry 5 times if 500 error
         * @returns {Promise<IGetLicenseResponse>}
         * @throws {FetchLicenseWithoutRetryError} if status error is 400
         * @throws {FetchLicenseError} if retries fail & 500 error
         * @throws {ApiError} generic api error
         */
        getLicense() {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    const response = (yield this.get(this.routeBuild(License.Route, this.configService.appDomain.product, this.configService.appDomain.region)));
                    const licenseData = first(response.geocomply_license);
                    return licenseData;
                }
                catch (error) {
                    if (error.response) {
                        const { response: { status }, } = error;
                        /**
                         * HTTP 4xx fail with no retry
                         */
                        if (http400Match(status)) {
                            throw new FetchLicenseWithoutRetryError();
                        }
                        /**
                         * HTTP 5xx fail with retry
                         */
                        if (http500Match(status)) {
                            throw new FetchLicenseError();
                        }
                    }
                    /**
                     * Throw generic api when not http error
                     */
                    throw new ApiError();
                }
            });
        }
        /**
         * Method to post expired license and recieve updated license for product & state
         * @remarks It can retry 5 times (3 seconds between) if 500 error
         * @param {string} expiredLicense - expired license
         * @returns {Promise<IGetLicenseResponse>}
         * @throws {RefreshLicenseWithoutRetryError} if status error is 400
         * @throws {RefreshLicenseError} if retries fail & 500 error
         * @throws {ApiError} generic api error
         */
        getNewLicense(expiredLicense) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    const response = (yield this.post(this.routeBuild(License.Route, this.configService.appDomain.product, this.configService.appDomain.region), { license: expiredLicense }));
                    const licenseData = first(response.geocomply_license);
                    return licenseData;
                }
                catch (error) {
                    if (error.response) {
                        const { response: { status }, } = error;
                        /**
                         * HTTP 4xx fail with no retry
                         */
                        if (http400Match(status)) {
                            throw new RefreshLicenseWithoutRetryError();
                        }
                        /**
                         * HTTP 5xx fail with retry
                         */
                        if (http500Match(status)) {
                            throw new RefreshLicenseError();
                        }
                    }
                    /**
                     * Throw generic error
                     */
                    throw new ApiError();
                }
            });
        }
        routeBuild(url, product, state) {
            return `${url}/${state.toUpperCase()}/${productMap(product)}`;
        }
    };
    __decorate([
        canRetry({ maxRetries: 5, retryErrors: [FetchLicenseError], timeoutDuration: 1000 }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], LicenseAPI.prototype, "getLicense", null);
    __decorate([
        canRetry({ maxRetries: 5, retryErrors: [RefreshLicenseError], timeoutDuration: 1000 }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", Promise)
    ], LicenseAPI.prototype, "getNewLicense", null);
    LicenseAPI = __decorate([
        tsyringe.singleton(),
        __metadata("design:paramtypes", [ConfigService, LoggerService])
    ], LicenseAPI);

    let LicenseService = class LicenseService {
        /**
         * Constructor method
         * @param licenseCache
         * @param licenseApi
         * @param configService
         */
        constructor(licenseCache, licenseApi, configService) {
            this.licenseCache = licenseCache;
            this.licenseApi = licenseApi;
            this.configService = configService;
            this.currentPendingRequest = null;
        }
        /**
         * @public Method to get license from either cache or FD API service
         * 1. valid license in cache, returns license from licenseCache service
         * 2. missing license / wrong product or region in cache, gets license from FD API
         * 3. invalid license (expired), get new license from FD API
         * @param {ILicenseOptions} options - force an InvalidLicenseError and refresh license
         * @returns {Promise<string>} license
         * @throws {MissingLicenseError} missing in cache or wrong product or state
         * @throws {InvalidLicenseError} invalid license
         * @throws all errors to be handled by the delegate method
         */
        fetchLicense(options) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    const license = this.licenseCache.getLicenseFromCache();
                    if (options === null || options === void 0 ? void 0 : options.refreshLicense) {
                        throw new InvalidLicenseError(License$1.Invalid, license);
                    }
                    return license;
                }
                catch (cachedLicenseErr) {
                    /**
                     * GET request - missing in cache or wrong product or state
                     */
                    if (cachedLicenseErr instanceof MissingLicenseError) {
                        try {
                            return yield this.setAndReturnLicense();
                        }
                        catch (apiLicenseError) {
                            if (apiLicenseError instanceof InvalidLicenseError) {
                                const invalidLicense = apiLicenseError.license;
                                return yield this.setAndReturnRefreshedLicense(invalidLicense);
                            }
                            throw apiLicenseError;
                        }
                    }
                    /**
                     * POST request - invalid date
                     */
                    if (cachedLicenseErr instanceof InvalidLicenseError) {
                        const invalidLicense = cachedLicenseErr.license;
                        return yield this.setAndReturnRefreshedLicense(invalidLicense);
                    }
                    /**
                     * None of the above errors - throw generic error to be handled by the error handler
                     */
                    throw cachedLicenseErr;
                }
            });
        }
        /**
         * @public Method to get license from FD API and update license in cache
         * @returns {Promise<string>}
         * @throws error from GET license request or setting license
         */
        setAndReturnLicense() {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    const licenseData = yield this.performLicenseRequest(() => {
                        return this.licenseApi.getLicense();
                    });
                    if (this.licenseCache.isValid(licenseData)) {
                        this.licenseCache.setLicense(licenseData);
                        return licenseData.license;
                    }
                }
                catch (err) {
                    throw err;
                }
            });
        }
        /**
         * @public Method to fetch new refresh license, set in cache and return
         * @param {string} invalidLicense
         * @returns {Promise<string>}
         * @throws error from POST license request
         */
        setAndReturnRefreshedLicense(invalidLicense) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    const newLicenseData = yield this.performLicenseRequest(() => {
                        return this.licenseApi.getNewLicense(invalidLicense);
                    });
                    if (this.licenseCache.isValid(newLicenseData)) {
                        this.licenseCache.setLicense(newLicenseData);
                        return newLicenseData.license;
                    }
                }
                catch (err) {
                    throw err;
                }
            });
        }
        /**
         * @public Method to remove the license from the license service and clear pending reqeust
         * @returns {void}
         */
        resetLicense() {
            this.licenseCache.removeLicense();
            this.clearRequestInProgress();
        }
        /**
         * @private Method to request a license
         * @param promiseRequest - method to make the request with ability to compose any request method (GET OR POST)
         * @returns {Promise<ILicenseData | null>} formatted license object when sucessful or null upon failure
         * @throws {InProgressError} if still trying to fetch license
         * @throws error from the network request callback call
         */
        performLicenseRequest(promiseRequest) {
            return __awaiter(this, void 0, void 0, function* () {
                /**
                 * If same request is currently being made - alert app that it is already in progress
                 */
                if (this.similarRequestInProgress()) {
                    throw new InProgressError();
                }
                /**
                 * Used to know if license request is in progress
                 */
                this.setLicenseFetchInProgress();
                try {
                    const result = yield promiseRequest();
                    const { expiry_date: expiry, license, state, product } = result;
                    this.clearRequestInProgress();
                    return { expiry, license, state, product };
                }
                catch (err) {
                    this.clearRequestInProgress();
                    throw err;
                }
            });
        }
        /**
         * @private Method to set current request promise and promise details to the instance
         * @returns {void}
         */
        setLicenseFetchInProgress() {
            const requestDetails = {
                product: this.configService.appDomain.product,
                region: this.configService.appDomain.region,
            };
            this.currentPendingRequest = requestDetails;
        }
        /**
         * @private Method to return true or false if similar request is in progress
         * Criteria for similar request:
         * 1.Same prduct
         * 2.Same region (state)
         * @returns {boolean}
         */
        similarRequestInProgress() {
            if (this.currentPendingRequest) {
                try {
                    const productIsTheSame = this.configService.appDomain.product === this.currentPendingRequest.product;
                    const regionIsTheSame = this.configService.appDomain.region === this.currentPendingRequest.region;
                    return productIsTheSame && regionIsTheSame;
                }
                catch (_a) {
                    return false;
                }
            }
            /**
             * No request in progress
             */
            return false;
        }
        /**
         * @private Method to reset license in progress after promise resolved
         * @returns {void}
         */
        clearRequestInProgress() {
            this.currentPendingRequest = null;
        }
    };
    LicenseService = __decorate([
        tsyringe.singleton(),
        __metadata("design:paramtypes", [LicenseCache,
            LicenseAPI,
            ConfigService])
    ], LicenseService);

    const LOCATION_IN_PROGRESS = 'aw-geolocation/location-in-progress';
    const GEOLOCATION_PASSED = 'aw-geolocation/geolocation-passed';
    const GEOLOCATION_REJECTED = 'aw-geolocation/geolocation-rejected';
    const LOCATION_FAILURE = 'aw-geolocation/location-failure';
    class GeolocationSDKConfig extends BaseSDKInitConfig {
        constructor(init) {
            super(init);
        }
    }
    __decorate([
        required,
        __metadata("design:type", Object)
    ], GeolocationSDKConfig.prototype, "appDomain", void 0);
    __decorate([
        required,
        __metadata("design:type", String)
    ], GeolocationSDKConfig.prototype, "clientId", void 0);
    __decorate([
        required,
        __metadata("design:type", String)
    ], GeolocationSDKConfig.prototype, "environment", void 0);
    __decorate([
        required,
        __metadata("design:type", String)
    ], GeolocationSDKConfig.prototype, "appVersion", void 0);
    __decorate([
        required,
        __metadata("design:type", String)
    ], GeolocationSDKConfig.prototype, "appName", void 0);
    var Reasons;
    (function (Reasons) {
        Reasons["IP_MISMATCH_REASON"] = "IP changed";
        Reasons["REFRESH_REASON"] = "Renew Location";
        Reasons["DEFAULT_REASON"] = "Unknown";
    })(Reasons || (Reasons = {}));

    /**
     * Parse the data from geolocation config interface to the shared configService interface
     */
    const geoLocationConfigParser = (geoConfig) => {
        const parsedConfig = new GeolocationSDKConfig();
        Object.assign(parsedConfig, geoConfig);
        parsedConfig.clientId = geoConfig.clientAuthToken;
        return parsedConfig;
    };
    const getPluginConfig = (geoConfig) => {
        const { environment, installerKey } = geoConfig;
        return {
            environmentId: environment.toLowerCase() === 'prod' ? 'production' : 'staging',
            installerKey,
        };
    };

    var GeoComply;
    (function (GeoComply) {
        GeoComply["VERSION"] = "3.1.1.3";
        GeoComply["DEV_PLUGIN"] = "net";
        GeoComply["PROD_PLUGIN"] = "com";
    })(GeoComply || (GeoComply = {}));

    var MissingDataMessage;
    (function (MissingDataMessage) {
        MissingDataMessage["ClientAuthToken"] = "Missing clientAuthToken";
        MissingDataMessage["AppDomainProduct"] = "Missing product name AppDomain.product";
        MissingDataMessage["EnvironmentType"] = "Missing environment.type from environment";
        MissingDataMessage["SessionAuthToken"] = "Missing userAuthToken from session";
        MissingDataMessage["SessionUserId"] = "Missing userId from session";
        MissingDataMessage["SessionId"] = "Missing sessionId from session";
        MissingDataMessage["InstallerKey"] = "Missing installerKey";
        MissingDataMessage["AppVersion"] = "Missing appVersion";
        MissingDataMessage["AppName"] = "Missing appName";
        MissingDataMessage["LocationToken"] = "Missing token for locationTokenParser call";
        MissingDataMessage["TokenData"] = "Missing data for documentParser call";
    })(MissingDataMessage || (MissingDataMessage = {}));

    var geocomply_min = {exports: {}};

    (function (module) {
    	!function(a,b){module.exports?module.exports=b():window.GeoComply=b();}(0,function(){var a={};if(Object.defineProperty)try{Object.defineProperty({},'test',{get:function(){return !0}});}catch(b){a=document;}return a.Client=function(){function b(a,b){if(a=a.toLowerCase(),void 0!==qa[a]&&'function'==typeof b)if('function'==typeof qa[a]){var c=qa[a];qa[a]=function(){c.apply(this,arguments),b.apply(this,arguments);};}else qa[a]=function(){b.apply(this,arguments);};return this}function c(a){return a=(a||'').toLowerCase(),''===a?qa={connect:null,geolocation:null,error:null,log:null}:void 0!==qa[a]&&'function'==typeof qa[a]&&(qa[a]=null),this}function d(a){if(a=a.toLowerCase(),void 0!==qa[a]&&'function'==typeof qa[a]){var b=arguments;b=Array.prototype.slice.call(b),b.shift(),window.setTimeout(function(){qa[a].apply(this,b);},0);}}function e(){return void 0!==a.Client.debug&&a.Client.debug}function f(){return !e()||void 0===a.Client.enableWS||a.Client.enableWS}function g(){return !!e()&&void 0!==a.Client.forceWSFail&&a.Client.forceWSFail}function h(a,b){for(var c=[],d=0;d<a.length;d++)a[d]!==b&&c.push(a[d]);return c}function i(a){var b,c=!0;for(var e in a)void 0!==(b=a[e])&&''!==b.trim()||(d('error',W,'Connect method is missing required parameter '+e+'.  Please specify it and try again'),c=!1);return c}function j(a,b,c,d){for(var e,f=0,g=[],h=0,i=[],j=(function(){var a=new XMLHttpRequest;return 'withCredentials'in a||(a='undefined'==typeof XDomainRequest?null:new XDomainRequest),a}),k=function(){f++,(window.XDomainRequest&&this instanceof XDomainRequest||200===this.status&&this.getResponseHeader('PLC-Installed-Versions'))&&(e=parseInt(this.requestPort),g=window.XDomainRequest&&this instanceof XDomainRequest?this.responseText.split(','):g.concat(this.getResponseHeader('PLC-Installed-Versions').split(','))),'function'!=typeof d||f!==b.length&&!e||window.setTimeout(function(){d(e,g,h,i);},0);},l=function(){f++,h++,i.push(parseInt(this.requestPort)),'function'!=typeof d||f!==b.length||e||window.setTimeout(function(){d(e,g,h,i);},0);},m=function(){f++,'function'!=typeof d||f!==b.length||e||window.setTimeout(function(){d(e,g,h,i);},0);},n=0;n<b.length;n++)!function(b){var d=j();d.onload=k,d.onerror=l,d.ontimeout=m,d.requestUrl=a+':'+b+'/check?t='+(new Date).getTime(),d.requestPort=b,d.open(window.XDomainRequest&&d instanceof XDomainRequest?'GET':'HEAD',d.requestUrl),d.timeout=c,d.send();}(b[n]);}function k(){0===ca?j('https://wss.plc-gc.com',ba,1e3,function(a,b,c,e){if(ha||(la.license=void 0,la.userID=void 0,la.geolocationReason=void 0,la.userPhoneNumber=void 0,na={}),a||c){if(a&&-1===b.indexOf(Y)){return void d('error',V,'Local service is installed but no supported version detected.');}da=a?[a]:e||ba,l(da);}else ha?(ca=0,ka&&(ka=!1,d('error',U,'An error occurred while posting data to a local service, WebSocket was closed while attempt to reconnect during geolocation'))):d('error',T,'Cannot connect to local service, PLC has not responded on specified ports');}):da.length>ca?l(da):d('error',T,'Cannot connect to local service, PLC was not detected on any of available ports');}function l(a){if('wss'===aa){var b=g()?a[ca]+10:a[ca];try{O=new WebSocket(aa+'://wss.plc-gc.com:'+b),Q=window.setTimeout(function(){window.setTimeout(function(){window.clearTimeout(Q),ga||void 0===O||O.close();},0);},pa);}catch(a){}}O?(O.onmessage=function(a){e()&&d('log','Response received: '+a.data);try{J(JSON.parse(a.data));}catch(a){d('error',U,'Could not parse a response from a local service ('+a+')');}},O.onopen=function(){window.clearTimeout(Q),e()&&d('log','Connection established. Sending handshake...'),o({handshake_req:{version:Y,browser:ra.name+' '+ra.version,js_lib_version:X,installer_key:M,env:N}});},O.onclose=function(){window.clearTimeout(Q),window.clearInterval(P),ga?(ga=!1,ia?(ia=!1,ka=!1,ha=!1,_='',O=void 0,aa='wss'):''===_?(O=void 0,k()):(ha=!0,O=void 0,ka&&(ka=!1,d('error',U,'An error occurred while posting data to a local service, WebSocket was closed unexpectedly during geolocation')))):a.length-1>ca?(ca++,O=void 0,k()):ha?(ca=0,ka&&(ka=!1,d('error',U,'An error occurred while posting data to a local service, WebSocket was closed while attempt to reconnect during geolocation'))):(O=void 0,d('error',T,'Cannot connect to local service, PLC has not responded on specified ports'));}):(ca++,O=void 0,k());}function m(a,b,c){if(i({installerKey:a,environmentId:b})){if(-1===$.indexOf(b))return void d('error',W,'Parameter environmentId has wrong value. Please try again with one of the allowed values');M=a,N=b,Y=void 0===c?Y:c,ca=0,ga&&(e()&&d('log','Already connected. Disconnecting...'),n()),d('log','Connecting...'),ea&&f()?(e()&&d('log','Connect using WebSockets...'),k()):(e()&&d('log','WebSockets are unsupported.'),d('error',T,'Cannot connect to local service, WebSockets are not supported'));}}function n(){window.clearInterval(P),P=void 0,void 0!==O&&(O.readyState<2||4===O.readyState)?(ia=!0,O.close()):(ia=!1,ka=!1,ha=!1,O=void 0,aa='wss');}function o(a){var b=JSON.stringify(a);e()&&d('log','Posting data to socket : '+b);try{O.send(b);}catch(a){ka=!1,d('error',U,'An error occurred while posting data to a local service, error during sending data through WebSocket');}}function p(){return _}function q(){return X}function r(){return Z}function s(a){return la.license!==a&&(la.license=a,-1===ma.indexOf('license')&&ma.push('license')),this}function t(){return la.license}function u(a){return la.userID!==a&&(la.userID=a,-1===ma.indexOf('user_id')&&ma.push('user_id')),this}function v(){return la.userID}function w(a){return la.geolocationReason!==a&&(la.geolocationReason=a,-1===ma.indexOf('geolocation_reason')&&ma.push('geolocation_reason')),this}function x(){return la.geolocationReason}function y(a){return la.userPhoneNumber!==a&&(la.userPhoneNumber=a,-1===ma.indexOf('user_phone_number')&&ma.push('user_phone_number')),this}function z(){return la.userPhoneNumber}function A(){return ja}function B(){ka&&e()&&d('log','Geolocation already requested'),ka=!0,ga?I():ha?(e()&&d('log','Reconnecting...'),k()):(ka=!1,d('error',U,'An error occurred while posting data to a local service, attempt to send data without being previously connected'));}function C(){return ga||ha}function D(a,b){return na[a]!==b&&(na[a]=b,-1===oa.indexOf(a)&&oa.push(a)),this}function E(a){return a in na?na[a]:void 0}function F(a){return D(a,void 0),this}function G(){return oa=['#clear#'],na={},this}function H(a,b,c){o({execute_command:{session:fa,command:a,params:b,values:c}});}function I(){if(!ha&&ka&&0===ma.length&&0===oa.length)return void H('REQUEST_GEOLOCATION',[],[]);var a={license:['SET_LICENSE','license'],user_id:['SET_USER_ID','userID'],geolocation_reason:['SET_GEOLOCATION_REASON','geolocationReason'],user_phone_number:['SET_USER_PHONE_NUMBER','userPhoneNumber']};if(ha){for(var b in a)-1===ma.indexOf(b)&&void 0!==la[a[b][1]]&&ma.push(b);for(var c in na)-1===oa.indexOf(c)&&oa.push(c);}if(ma.length)return void H(a[ma[0]][0],[ma[0]],[la[a[ma[0]][1]]]);if(oa.length){var d=oa[0],e=na[d];'#clear#'===d?H('CLEAR_CUSTOM_FIELDS',[],[]):na.hasOwnProperty(d)&&(void 0===e?H('REMOVE_CUSTOM_FIELD',['key'],[d]):H('SET_CUSTOM_FIELD',['key','value'],[d,e]));}}function J(a){var b;if(a.handshake_resp)b=a.handshake_resp,ja=b.lastErrorCode,ga='0'===b.lastErrorCode,ga&&'true'===b.is_supported?(fa=b.session,_=b.version,D('own','plugin'),'wss'===aa&&(P&&clearInterval(P),P=window.setInterval(function(){e()&&d('log','Keep alive message sent'),o({async_event:{session:fa,event:'EVENT_ON_KEEP_ALIVE',params:[],values:[]}});},2e4)),ha?(ka&&I(),ha=!1):d('connect')):'false'===b.is_supported&&((n(),d('error',V,'Local service is installed but no supported version detected.')));else if(a.execute_command)switch(b=a.execute_command,ja=b.lastErrorCode,b.command){case'SET_LICENSE':'true'===b.result?(ma=h(ma,'license'),I()):(ka=!1,d('error',S,'Invalid license format'));break;case'SET_USER_ID':'true'===b.result?(ma=h(ma,'user_id'),I()):(ka=!1,d('error',R,'Error setting user id'));break;case'SET_GEOLOCATION_REASON':'true'===b.result?(ma=h(ma,'geolocation_reason'),I()):(ka=!1,d('error',R,'Error setting geolocation reason'));break;case'SET_USER_PHONE_NUMBER':'true'===b.result?(ma=h(ma,'user_phone_number'),I()):(ka=!1,d('error',R,'Error setting user phone number'));break;case'SET_CUSTOM_FIELD':'own'===b.values[0]||'true'===b.result?(oa=h(oa,b.values[0]),I()):(ka=!1,d('error',R,'Error setting custom field "'+b.values[0]+'"'));break;case'REMOVE_CUSTOM_FIELD':'true'===b.result?(oa=h(oa,b.values[0]),I()):(ka=!1,d('error',R,'Error removing custom field'));break;case'CLEAR_CUSTOM_FIELDS':'true'===b.result?(oa=h(oa,'#clear#'),I()):(ka=!1,d('error',R,'Error clearing custom fields'));break;case'GET_USER_ID':'true'===b.result&&(la.userID=b.result);break;case'GET_GEOLOCATION_REASON':'true'===b.result&&(la.geolocationReason=b.result);break;case'GET_USER_PHONE_NUMBER':'true'===b.result&&(la.userPhoneNumber=b.result);break;case'GET_CUSTOM_FIELD':b.result.length>0&&D(b.values[0],b.result);break;case'REQUEST_GEOLOCATION':'false'===b.result&&(ka=!1,d('error',b.lastErrorCode,'Couldn\'t request a geolocation.'));break;case'GET_VERSION':'true'===b.result&&(_=b.result);break;case'GET_LAST_ERROR_CODE':'true'===b.result&&(ja=b.result);}else if(a.async_event)switch(b=a.async_event,ja=b.lastErrorCode,b.event){case'EVENT_ON_GEOLOCATION_AVAILABLE':ka=!1,d('geolocation',b.values[0]);break;case'EVENT_ON_GEOLOCATION_FAILED':var c=0,f=1;b.params&&(c=b.params.indexOf('errorCode'),f=b.params.indexOf('errorMessage')),ka=!1,d('error',b.values[c],b.values[f]);}}function K(){switch(aa){case'wss':return 'Secure WebSocket'}}function L(a,b){j('https://wss.plc-gc.com',ba,a,function(a,c){b(a,c);});}var M,N,O,P,Q,R=600,S=606,T=612,U=613,V=615,W=699,X='3.1.1.3',Y='3.1.1.3',Z='',$=['production','staging','qat','test','dev'],_='',aa='wss',ba=[9703,9704,9705],ca=0,da=[],ea='WebSocket'in window&&2===window.WebSocket.CLOSING,fa='',ga=!1,ha=!1,ia=!1,ja=0,ka=!1,la={license:void 0,userID:void 0,geolocationReason:void 0,userPhoneNumber:void 0},ma=[],na={},oa=[],pa=2e3,qa={connect:null,geolocation:null,error:null,log:null},ra=function(){function a(a){function b(b){var c=a.match(b);return c&&c.length>1&&c[1]||''}var c,d=b(/(ipod|iphone|ipad)/i).toLowerCase(),e=/like android/i.test(a),f=!e&&/android/i.test(a),h=/nexus\s*[0-6]\s*/i.test(a),i=!h&&/nexus\s*[0-9]+/i.test(a),j=/CrOS/.test(a),k=/silk/i.test(a),l=/sailfish/i.test(a),m=/tizen/i.test(a),n=/(web|hpw)os/i.test(a),o=/windows phone/i.test(a),p=(/SamsungBrowser/i.test(a),!o&&/windows/i.test(a)),q=!d&&!k&&/macintosh/i.test(a),r=!f&&!l&&!m&&!n&&/linux/i.test(a),s=b(/edge\/(\d+(\.\d+)?)/i),t=b(/version\/(\d+(\.\d+)?)/i),u=/tablet/i.test(a),v=!u&&/[^-]mobi/i.test(a),w=/xbox/i.test(a);/opera/i.test(a)?c={name:'Opera',opera:g,version:t||b(/(?:opera|opr|opios)[\s\/](\d+(\.\d+)?)/i)}:/opr|opios/i.test(a)?c={name:'Opera',opera:g,version:b(/(?:opr|opios)[\s\/](\d+(\.\d+)?)/i)||t}:/SamsungBrowser/i.test(a)?c={name:'Samsung Internet for Android',samsungBrowser:g,version:t||b(/(?:SamsungBrowser)[\s\/](\d+(\.\d+)?)/i)}:/coast/i.test(a)?c={name:'Opera Coast',coast:g,version:t||b(/(?:coast)[\s\/](\d+(\.\d+)?)/i)}:/yabrowser/i.test(a)?c={name:'Yandex Browser',yandexbrowser:g,version:t||b(/(?:yabrowser)[\s\/](\d+(\.\d+)?)/i)}:/ucbrowser/i.test(a)?c={name:'UC Browser',ucbrowser:g,version:b(/(?:ucbrowser)[\s\/](\d+(?:\.\d+)+)/i)}:/mxios/i.test(a)?c={name:'Maxthon',maxthon:g,version:b(/(?:mxios)[\s\/](\d+(?:\.\d+)+)/i)}:/epiphany/i.test(a)?c={name:'Epiphany',epiphany:g,version:b(/(?:epiphany)[\s\/](\d+(?:\.\d+)+)/i)}:/puffin/i.test(a)?c={name:'Puffin',puffin:g,version:b(/(?:puffin)[\s\/](\d+(?:\.\d+)?)/i)}:/sleipnir/i.test(a)?c={name:'Sleipnir',sleipnir:g,version:b(/(?:sleipnir)[\s\/](\d+(?:\.\d+)+)/i)}:/k-meleon/i.test(a)?c={name:'K-Meleon',kMeleon:g,version:b(/(?:k-meleon)[\s\/](\d+(?:\.\d+)+)/i)}:o?(c={name:'Windows Phone',windowsphone:g},s?(c.msedge=g,c.version=s):(c.msie=g,c.version=b(/iemobile\/(\d+(\.\d+)?)/i))):/msie|trident/i.test(a)?c={name:'Internet Explorer',msie:g,version:b(/(?:msie |rv:)(\d+(\.\d+)?)/i)}:j?c={name:'Chrome',chromeos:g,chromeBook:g,chrome:g,version:b(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)}:/chrome.+? edge/i.test(a)?c={name:'Microsoft Edge',msedge:g,version:s}:/vivaldi/i.test(a)?c={name:'Vivaldi',vivaldi:g,version:b(/vivaldi\/(\d+(\.\d+)?)/i)||t}:l?c={name:'Sailfish',sailfish:g,version:b(/sailfish\s?browser\/(\d+(\.\d+)?)/i)}:/seamonkey\//i.test(a)?c={name:'SeaMonkey',seamonkey:g,version:b(/seamonkey\/(\d+(\.\d+)?)/i)}:/firefox|iceweasel|fxios/i.test(a)?(c={name:'Firefox',firefox:g,version:b(/(?:firefox|iceweasel|fxios)[ \/](\d+(\.\d+)?)/i)},/\((mobile|tablet);[^\)]*rv:[\d\.]+\)/i.test(a)&&(c.firefoxos=g)):k?c={name:'Amazon Silk',silk:g,version:b(/silk\/(\d+(\.\d+)?)/i)}:/phantom/i.test(a)?c={name:'PhantomJS',phantom:g,version:b(/phantomjs\/(\d+(\.\d+)?)/i)}:/slimerjs/i.test(a)?c={name:'SlimerJS',slimer:g,version:b(/slimerjs\/(\d+(\.\d+)?)/i)}:/blackberry|\bbb\d+/i.test(a)||/rim\stablet/i.test(a)?c={name:'BlackBerry',blackberry:g,version:t||b(/blackberry[\d]+\/(\d+(\.\d+)?)/i)}:n?(c={name:'WebOS',webos:g,version:t||b(/w(?:eb)?osbrowser\/(\d+(\.\d+)?)/i)},/touchpad\//i.test(a)&&(c.touchpad=g)):/bada/i.test(a)?c={name:'Bada',bada:g,version:b(/dolfin\/(\d+(\.\d+)?)/i)}:m?c={name:'Tizen',tizen:g,version:b(/(?:tizen\s?)?browser\/(\d+(\.\d+)?)/i)||t}:/qupzilla/i.test(a)?c={name:'QupZilla',qupzilla:g,version:b(/(?:qupzilla)[\s\/](\d+(?:\.\d+)+)/i)||t}:/chromium/i.test(a)?c={name:'Chromium',chromium:g,version:b(/(?:chromium)[\s\/](\d+(?:\.\d+)?)/i)||t}:/chrome|crios|crmo/i.test(a)?c={name:'Chrome',chrome:g,version:b(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)}:f?c={name:'Android',version:t}:/safari|applewebkit/i.test(a)?(c={name:'Safari',safari:g},t&&(c.version=t)):d?(c={name:'iphone'==d?'iPhone':'ipad'==d?'iPad':'iPod'},t&&(c.version=t)):c=/googlebot/i.test(a)?{name:'Googlebot',googlebot:g,version:b(/googlebot\/(\d+(\.\d+))/i)||t}:{name:b(/^(.*)\/(.*) /),version:function x(b){var c=a.match(b);return c&&c.length>1&&c[2]||''}(/^(.*)\/(.*) /)},!c.msedge&&/(apple)?webkit/i.test(a)?(/(apple)?webkit\/537\.36/i.test(a)?(c.name=c.name||'Blink',c.blink=g):(c.name=c.name||'Webkit',c.webkit=g),!c.version&&t&&(c.version=t)):!c.opera&&/gecko\//i.test(a)&&(c.name=c.name||'Gecko',c.gecko=g,c.version=c.version||b(/gecko\/(\d+(\.\d+)?)/i)),c.windowsphone||c.msedge||!f&&!c.silk?c.windowsphone||c.msedge||!d?q?c.mac=g:w?c.xbox=g:p?c.windows=g:r&&(c.linux=g):(c[d]=g,c.ios=g):c.android=g;var y='';c.windowsphone?y=b(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i):d?(y=b(/os (\d+([_\s]\d+)*) like mac os x/i),y=y.replace(/[_\s]/g,'.')):f?y=b(/android[ \/-](\d+(\.\d+)*)/i):c.webos?y=b(/(?:web|hpw)os\/(\d+(\.\d+)*)/i):c.blackberry?y=b(/rim\stablet\sos\s(\d+(\.\d+)*)/i):c.bada?y=b(/bada\/(\d+(\.\d+)*)/i):c.tizen&&(y=b(/tizen[\/\s](\d+(\.\d+)*)/i)),y&&(c.osversion=y);var z=y.split('.')[0];return u||i||'ipad'==d||f&&(3==z||z>=4&&!v)||c.silk?c.tablet=g:(v||'iphone'==d||'ipod'==d||f||h||c.blackberry||c.webos||c.bada)&&(c.mobile=g),c.msedge||c.msie&&c.version>=10||c.yandexbrowser&&c.version>=15||c.vivaldi&&c.version>=1||c.chrome&&c.version>=20||c.samsungBrowser&&c.version>=4||c.firefox&&c.version>=20||c.safari&&c.version>=6||c.opera&&c.version>=10||c.ios&&c.osversion&&c.osversion.split('.')[0]>=6||c.blackberry&&c.version>=10.1||c.chromium&&c.version>=20?c.a=g:c.msie&&c.version<10||c.chrome&&c.version<20||c.firefox&&c.version<20||c.safari&&c.version<6||c.opera&&c.version<10||c.ios&&c.osversion&&c.osversion.split('.')[0]<6||c.chromium&&c.version<20?c.c=g:c.x=g,c}function b(a){return a.split('.').length}function c(a,b){var c,d=[];if(Array.prototype.map)return Array.prototype.map.call(a,b);for(c=0;c<a.length;c++)d.push(b(a[c]));return d}function d(a){for(var d=Math.max(b(a[0]),b(a[1])),e=c(a,function(a){var e=d-b(a);return a+=new Array(e+1).join('.0'),c(a.split('.'),function(a){return new Array(20-a.length).join('0')+a}).reverse()});--d>=0;){if(e[0][d]>e[1][d])return 1;if(e[0][d]!==e[1][d])return -1;if(0===d)return 0}}function e(b,c,e){var f=h;'string'==typeof c&&(e=c,c=void 0),void 0===c&&(c=!1),e&&(f=a(e));var g=''+f.version;for(var i in b)if(b.hasOwnProperty(i)&&f[i]){if('string'!=typeof b[i])throw new Error('Browser version in the minVersion map should be a string: '+i+': '+String(b));return d([g,b[i]])<0}return c}function f(a,b,c){return !e(a,b,c)}var g=!0,h=a('undefined'!=typeof navigator?navigator.userAgent||'':'');return h.test=function(a){for(var b=0;b<a.length;++b){var c=a[b];if('string'==typeof c&&c in h)return !0}return !1},h.isUnsupportedBrowser=e,h.compareVersions=d,h.check=f,h._detect=a,h}();return {CLNT_OK:0,CLNT_ERROR_UNEXPECTED:R,CLNT_ERROR_NOT_CERTIFIED_BINARIES:601,CLNT_ERROR_NETWORK_CONNECTION:602,CLNT_ERROR_SERVER_COMMUNICATION:603,CLNT_ERROR_CLIENT_SUSPENDED:604,CLNT_ERROR_DISABLED_SOLUTION:605,CLNT_ERROR_INVALID_LICENSE_FORMAT:S,CLNT_ERROR_CLIENT_LICENSE_UNAUTHORIZED:607,CLNT_ERROR_LICENSE_EXPIRED:608,CLNT_ERROR_INVALID_CUSTOM_FIELDS:609,CLNT_ERROR_LOCAL_SERVICE_UNAVAILABLE:T,CLNT_ERROR_LOCAL_SERVICE_COMMUNICATION:U,CLNT_ERROR_REQUEST_GEOLOCATION_IN_PROGRESS:614,CLNT_ERROR_LOCAL_SERVICE_UNSUP_VER:V,CLNT_ERROR_TRANSACTION_TIMEOUT:620,CLNT_ERROR_WRONG_OR_MISSING_PARAMETER:W,on:function(a,c){return b.call(this,a,c)},off:function(a){return c.call(this,a)},connect:function(){return m.apply(this,arguments)},disconnect:function(){n.call(this);},getVersion:function(){return p.call(this)},getJSLibraryVersion:function(){return q.call(this)},getFallbackVersion:function(){return r.call(this)},requestGeolocation:function(){B.call(this);},getLastErrorCode:function(){return A.call(this)},setLicense:function(a){return s.call(this,a)},getLicense:function(){return t.call(this)},setUserId:function(a){return u.call(this,a)},getUserId:function(){return v.call(this)},setGeolocationReason:function(a){return w.call(this,a)},getGeolocationReason:function(){return x.call(this)},setUserPhoneNumber:function(a){return y.call(this,a)},getUserPhoneNumber:function(){return z.call(this)},customFields:{set:function(a,b){return D.call(this,a,b)},get:function(a){return E.call(this,a)},remove:function(a){return F.call(this,a)},clear:function(){return G.call(this)}},isConnected:function(){return C.call(this)},getConnectionMethod:function(){return K.call(this)},detectInstall:function(a,b){L(a,b);}}}(),Object.defineProperties&&Object.defineProperties(a.Client,{CLNT_OK:{value:0,writable:!1,enumerable:!0,configurable:!1},CLNT_ERROR_UNEXPECTED:{value:600,writable:!1,enumerable:!0,configurable:!1},CLNT_ERROR_NOT_CERTIFIED_BINARIES:{value:601,writable:!1,enumerable:!0,configurable:!1},CLNT_ERROR_NETWORK_CONNECTION:{value:602,writable:!1,enumerable:!0,configurable:!1},CLNT_ERROR_SERVER_COMMUNICATION:{value:603,writable:!1,enumerable:!0,configurable:!1},CLNT_ERROR_CLIENT_SUSPENDED:{value:604,writable:!1,enumerable:!0,configurable:!1},CLNT_ERROR_DISABLED_SOLUTION:{value:605,writable:!1,enumerable:!0,configurable:!1},CLNT_ERROR_INVALID_LICENSE_FORMAT:{value:606,writable:!1,enumerable:!0,configurable:!1},CLNT_ERROR_CLIENT_LICENSE_UNAUTHORIZED:{value:607,writable:!1,enumerable:!0,configurable:!1},CLNT_ERROR_LICENSE_EXPIRED:{value:608,writable:!1,enumerable:!0,configurable:!1},CLNT_ERROR_INVALID_CUSTOM_FIELDS:{value:609,writable:!1,enumerable:!0,configurable:!1},CLNT_ERROR_LOCAL_SERVICE_UNAVAILABLE:{value:612,writable:!1,enumerable:!0,configurable:!1},CLNT_ERROR_LOCAL_SERVICE_COMMUNICATION:{value:613,writable:!1,enumerable:!0,configurable:!1},CLNT_ERROR_REQUEST_GEOLOCATION_IN_PROGRESS:{value:614,writable:!1,enumerable:!0,configurable:!1},CLNT_ERROR_LOCAL_SERVICE_UNSUP_VER:{value:615,writable:!1,enumerable:!0,configurable:!1},CLNT_ERROR_TRANSACTION_TIMEOUT:{value:620,writable:!1,enumerable:!0,configurable:!1},CLNT_ERROR_WRONG_OR_MISSING_PARAMETER:{value:699,writable:!1,enumerable:!0,configurable:!1}}),a.Events=function(){function b(a){if(a=a||window.event,a.isFixed)return a;if(a.isFixed=!0,a.preventDefault=a.preventDefault||function(){this.returnValue=!1;},a.stopPropagation=a.stopPropagation||function(){this.cancelBubble=!0;},a.target||(a.target=a.srcElement),!a.relatedTarget&&a.fromElement&&(a.relatedTarget=a.fromElement===a.target?a.toElement:a.fromElement),null===a.pageX&&null!==a.clientX){var b=document.documentElement,c=document.body;a.pageX=a.clientX+(b&&b.scrollLeft||c&&c.scrollLeft||0)-(b.clientLeft||0),a.pageY=a.clientY+(b&&b.scrollTop||c&&c.scrollTop||0)-(b.clientTop||0);}return !a.which&&a.button&&(a.which=1&a.button?1:2&a.button?3:4&a.button?2:0),a}function c(c){c=b(c);var e=d('beforeunload'===c.type?window:c.target),f=!1===e?[]:k[e].events[c.type];for(var g in f)!1===f[g].call(a.Events,c)&&(c.preventDefault(),c.stopPropagation());}function d(a){var b=!1;for(var c in k)if(k[c].target===a){b=c;break}return b}function e(b,e,f){b.setInterval&&b!==window&&!b.frameElement&&(b=window),f.guid||(f.guid=++j);var g=d(b);return !1===g&&(g=++i,k[g]={target:b,handle:function(d){if(void 0!==a.Events)return c.call(b,d)},events:[]}),void 0===k[g].events[e]&&(k[g].events[e]={}),b.addEventListener?b.addEventListener(e,k[g].handle,!1):b.attachEvent?b.attachEvent('on'+e,k[g].handle):b['on'+e]=k[g].handle,k[g].events[e][f.guid]=f,a.Events}function f(b,c,e){var f=d(b),g=!1!==f&&k[f].events[c];if(g)return e.guid&&(delete g[e.guid],Object.keys(k[f].events[c]).length||delete k[f].events[c],b.removeEventListener?b.removeEventListener(c,g[e.guid],!1):b.detachEvent?b.detachEvent('on'+c,g[e.guid]):delete b['on'+c]),a.Events}function g(b,c){if(document.createEvent){var d=document.createEvent('click'===c?'MouseEvents':'Event');'click'===c?d.initMouseEvent(c,!0,!0,window,0,0,0,0,0,!1,!1,!1,!1,0,null):d.initEvent(c,!0,!1),b.dispatchEvent(d);}else document.createEventObject?b.fireEvent('on'+c):'function'==typeof b['on'+c]&&b['on'+c]();return a.Events}function h(b,c){var d=!1,e=!0,f=b.document,g=f.documentElement,h=f.addEventListener?'addEventListener':'attachEvent',i=f.addEventListener?'removeEventListener':'detachEvent',j=f.addEventListener?'':'on',k=function(a){'readystatechange'===a.type&&'complete'!==f.readyState||(('load'===a.type?b:f)[i](j+a.type,k,!1),!d&&(d=!0)&&c.call(b,a.type||a));},l=function(){try{g.doScroll('left');}catch(a){return void setTimeout(l,50)}k('poll');};if('complete'===f.readyState)c.call(b,'lazy');else {if(f.createEventObject&&g.doScroll){try{e=!b.frameElement;}catch(a){}e&&l();}f[h](j+'DOMContentLoaded',k,!1),f[h](j+'readystatechange',k,!1),b[h](j+'load',k,!1);}return a.Events}var i=0,j=0,k={};return {add:function(a,b,c){return e.call(this,a,b,c)},remove:function(a,b,c){return f.call(this,a,b,c)},trigger:function(a,b){return g.call(this,a,b)},ready:function(a,b){return h.call(this,a,b)}}}(),a.createClient=function(b){return window.console&&a.Client.debug,a.Client.off(),a.Client.disconnect(),a.Client.on('connect',function(){b.onConnectSuccess.call(a.Client);}).on('geolocation',function(c){b.onGeolocationAvailable.call(a.Client,c);}).on('error',function(c,d){c===a.Client.CLNT_ERROR_LOCAL_SERVICE_UNAVAILABLE||c===a.Client.CLNT_ERROR_LOCAL_SERVICE_UNSUP_VER?b.onConnectFailed.call(a.Client,c,d):b.onGeolocationFailed.call(a.Client,c,d);}).on('log',function(c){b&&'function'==typeof b.onLog&&b.onLog.call(a.Client,c);}),a.Client.ErrorCodes={CLNT_OK:a.Client.CLNT_OK,CLNT_ERROR_UNEXPECTED:a.Client.CLNT_ERROR_UNEXPECTED,CLNT_ERROR_NOT_CERTIFIED_BINARIES:a.Client.CLNT_ERROR_NOT_CERTIFIED_BINARIES,CLNT_ERROR_NETWORK_CONNECTION:a.Client.CLNT_ERROR_NETWORK_CONNECTION,CLNT_ERROR_SERVER_COMMUNICATION:a.Client.CLNT_ERROR_SERVER_COMMUNICATION,CLNT_ERROR_CLIENT_SUSPENDED:a.Client.CLNT_ERROR_CLIENT_SUSPENDED,CLNT_ERROR_DISABLED_SOLUTION:a.Client.CLNT_ERROR_DISABLED_SOLUTION,CLNT_ERROR_INVALID_LICENSE_FORMAT:a.Client.CLNT_ERROR_INVALID_LICENSE_FORMAT,CLNT_ERROR_CLIENT_LICENSE_UNAUTHORIZED:a.Client.CLNT_ERROR_CLIENT_LICENSE_UNAUTHORIZED,CLNT_ERROR_LICENSE_EXPIRED:a.Client.CLNT_ERROR_LICENSE_EXPIRED,CLNT_ERROR_INVALID_CUSTOM_FIELDS:a.Client.CLNT_ERROR_INVALID_CUSTOM_FIELDS,CLNT_ERROR_LOCAL_SERVICE_UNAVAILABLE:a.Client.CLNT_ERROR_LOCAL_SERVICE_UNAVAILABLE,CLNT_ERROR_LOCAL_SERVICE_COMMUNICATION:a.Client.CLNT_ERROR_LOCAL_SERVICE_COMMUNICATION,CLNT_ERROR_REQUEST_GEOLOCATION_IN_PROGRESS:a.Client.CLNT_ERROR_REQUEST_GEOLOCATION_IN_PROGRESS,CLNT_ERROR_LOCAL_SERVICE_UNSUP_VER:a.Client.CLNT_ERROR_LOCAL_SERVICE_UNSUP_VER,CLNT_ERROR_TRANSACTION_TIMEOUT:a.Client.CLNT_ERROR_TRANSACTION_TIMEOUT,CLNT_ERROR_WRONG_OR_MISSING_PARAMETER:a.Client.CLNT_ERROR_WRONG_OR_MISSING_PARAMETER},Object&&'function'==typeof Object.freeze&&(a.Client.ErrorCodes=Object.freeze(a.Client.ErrorCodes)),a.Client},a.events=a.Events,Object.defineProperty&&(Object.defineProperty(a,'debug',{set:function(b){a.Client.debug=b;},get:function(){return a.Client.debug}}),Object.defineProperty(a,'enableWS',{set:function(b){window.console&&a.Client.debug,a.Client.enableWS=b;},get:function(){return window.console&&a.Client.debug,a.Client.enableWS}}),Object.defineProperty(a,'forceWSFail',{set:function(b){window.console&&a.Client.debug,a.Client.forceWSFail=b;},get:function(){return window.console&&a.Client.debug,a.Client.forceWSFail}})),a});
    } (geocomply_min));

    var GeoComplySDK = geocomply_min.exports;

    const sdkVersion = "4.1.1";

    let GeoComplyProvider = class GeoComplyProvider {
        /**
         * @constructor
         * @param configService
         */
        constructor(configService) {
            this.configService = configService;
            /**
             * @private Method to build PLC URL
             * @param {string} installerKey - key provided by GeoComply
             * @param {string} userId - user id from config
             * @param {string} version - plc version number
             * @param {string} ua - optional userAgent string for os detection
             * @returns {plugin}
             * @throws generic error for osDetection
             */
            this.pluginUrlBuilder = (installerKey, userId, version = GeoComply.VERSION, ua = navigator.userAgent) => {
                try {
                    const topLevelDomain = this.configService.isDev
                        ? GeoComply.DEV_PLUGIN
                        : GeoComply.PROD_PLUGIN;
                    const url = `https://ums.geocomply.${topLevelDomain}/installer/url?id=${installerKey}&os=${osDetection(ua)}&version=${version}&user_id=${userId}`;
                    return url;
                }
                catch (err) {
                    throw err;
                }
            };
        }
        /**
         * @public Method to initiate the connection with the GeoComply SDK.
         * Listen for onConnect, onError, onGeolocation and onLog events
         * The _sdk property will only be assigned when connection is not established.
         * @param  {IEnviromentDetails} config - object with requiered data
         * @param onError - callback to handle errors
         * @param onGeolocation - callback to handle location data
         * @param startGeolocationCallback - start geolocation process
         * @param _geoComplySdk - GeoComply JS library
         * @throws MissingDataError if installerKey or environmentId are not set
         */
        connect(config, onError, onGeolocation, onConnect, _geoComplySdk = GeoComplySDK) {
            if (this.isConnected())
                return;
            this.sdk = _geoComplySdk;
            const { environmentId, installerKey } = getPluginConfig(config);
            if (!installerKey) {
                throw new MissingDataError(MissingDataMessage.InstallerKey);
            }
            if (!environmentId) {
                throw new MissingDataError(MissingDataMessage.EnvironmentType);
            }
            /** only to be set once */
            if (!this.eventListenersSet) {
                this.addEventListeners(onError, onConnect, onGeolocation);
            }
            this._sdk.Client.connect(installerKey, environmentId);
        }
        /**
         * @public Method to set the event handlers for the GeoComply sdk
         * @param onError - error callback
         * @param startGeolocationCallback - start geolocation callback
         * @param onGeolocation - geolocated callback
         * @returns {void}
         */
        addEventListeners(onError, onConnect, onGeolocation) {
            try {
                this._sdk.Client.on('connect', () => {
                    onConnect();
                });
                this._sdk.Client.on('error', (errorCode, errorMessage) => {
                    onError(new GeoComplyError(errorCode, errorMessage));
                });
                this._sdk.Client.on('geolocation', (data) => {
                    onGeolocation(data);
                });
                this._sdk.Client.on('log', () => { });
                window.addEventListener('beforeunload', () => {
                    this.disconnect();
                });
                this.eventListenersSet = true;
            }
            catch (err) {
                throw err;
            }
        }
        /**
         * @setter for GeoComply sdk
         * @remarks checks if it is null
         */
        set sdk(sdk) {
            if (!this._sdk) {
                this._sdk = sdk;
            }
        }
        /**
         * @setter for event listener flag
         */
        set eventListenersSet(val) {
            this._eventListenersSet = val;
        }
        /**
         * @getter for event listener flag
         */
        get eventListenersSet() {
            return this._eventListenersSet;
        }
        /**
         * @public Method to check if the connection between JS library
         * and local service has started successfully
         * @returns {boolean}
         */
        isConnected() {
            var _a;
            return Boolean(((_a = this._sdk) === null || _a === void 0 ? void 0 : _a.Client) && this._sdk.Client.isConnected());
        }
        /**
         * @public Method to close the connection between JS library and local service
         * that is attached to the beforeuload window listenener
         */
        disconnect() {
            this._sdk.Client.disconnect();
        }
        /**
         * @public Method to geolocate the user through the GeoComply SDK
         * @param {string} license - license from FD service
         * @param {string} reason - reason for geolocation this helps GeoComply for debugging
         */
        geolocateUser(license, reason) {
            if (!license) {
                throw new MissingDataError('missing license for geolocate call');
            }
            if (!reason) {
                throw new MissingDataError('missing reason for geolocate call');
            }
            if (!this.configService.session.sessionId) {
                throw new MissingDataError('missing sessionId from config service');
            }
            if (!this.configService.session.userId) {
                throw new MissingDataError('missing userId from config service');
            }
            /** set license for geolocation */
            this._sdk.Client.setLicense(license);
            /** set reason for geoloction */
            this._sdk.Client.setGeolocationReason(reason);
            /** set user who is logged into the app with unique id */
            this._sdk.Client.setUserId(this.configService.session.userId);
            /** set custom fields */
            this._sdk.Client.customFields.set('session_id', this.configService.session.sessionId);
            this._sdk.Client.customFields.set('product', productMap(this.configService.appDomain.product));
            this._sdk.Client.customFields.set('app_version', this.configService.appVersion);
            this._sdk.Client.customFields.set('app_name', this.configService.appName);
            this._sdk.Client.customFields.set('sdk_version', sdkVersion);
            /** request the user's location */
            this._sdk.Client.requestGeolocation();
        }
        /**
         * @public Method to get the PLC URL upon plugin error
         * @param ua - user agent for the current browser
         * @param {string} version - GeoComply version
         * @returns {plugin} download URL for PLC
         */
        requestPluginUrl(ua = navigator.userAgent, version = GeoComply.VERSION) {
            return this.pluginUrlBuilder(this.configService.installerKey, this.configService.session.userId, version, ua);
        }
    };
    GeoComplyProvider = __decorate([
        tsyringe.singleton(),
        __metadata("design:paramtypes", [ConfigService])
    ], GeoComplyProvider);

    class SchedulerService {
        constructor() {
            this._timer = null;
            this.attempts = 0;
        }
        /**
         * @public Method to check whether the timer has been set
         * @returns {boolean}
         */
        timerSet() {
            return Boolean(this._timer);
        }
    }

    /**
     * Scheduler service - basic timeout service
     */
    let TimeoutScheduler = class TimeoutScheduler extends SchedulerService {
        constructor() {
            super();
        }
        /**
         * @public Method to start the setTimeout timer
         * @param {number | null} interval in milliseconds
         * @param {Function} callback function to run once interval is complete
         */
        startTimer(interval, callback) {
            const notNumber = interval === null || typeof interval !== 'number';
            if (notNumber) {
                throw new Error('interval must be a number');
            }
            return (this._timer = window.setTimeout(callback, interval));
        }
        /**
         * @public Method to stop timer and clear timer instance
         */
        stopTimer() {
            window.clearTimeout(this._timer);
            this._timer = null;
        }
    };
    TimeoutScheduler = __decorate([
        BrowserOnly(),
        tsyringe.injectable(),
        __metadata("design:paramtypes", [])
    ], TimeoutScheduler);

    let IpScheduler = class IpScheduler {
        constructor(timeoutScheduler) {
            this.timeoutScheduler = timeoutScheduler;
            /**
             * @public Method to initiate the scheduler for the IP address changes
             * @param {number} interval - interval time for checking IP address
             * @param handleIpChange - method to check IP every 15 seconds
             * @param errorHandlerCb - callback to run when error occurs - takes error instance
             * @returns {Promise<void>}
             */
            this.startTimer = (interval, handleIpChange, errorHandlerCb) => __awaiter(this, void 0, void 0, function* () {
                try {
                    /**
                     * Throw errors to be caught in the catch and passed to error handler
                     */
                    if (!interval) {
                        throw new MissingDataError('interval time must be greater than 0 seconds');
                    }
                    if (!handleIpChange) {
                        throw new MissingDataError('missing ip change callback');
                    }
                    yield handleIpChange(Reasons.IP_MISMATCH_REASON);
                    /**
                     * Recursive polling when all is successful
                     */
                    this.timeoutScheduler.startTimer(interval, () => this.startTimer(interval, handleIpChange, errorHandlerCb));
                }
                catch (err) {
                    /**
                     * Call the client error handler with the err instance and clear timer
                     */
                    this.stopTimer();
                    errorHandlerCb(err);
                }
            });
        }
        /**
         * @public Method to reset the timer
         */
        stopTimer() {
            this.timeoutScheduler.stopTimer();
        }
        isSet() {
            return this.timeoutScheduler.timerSet();
        }
    };
    IpScheduler = __decorate([
        tsyringe.singleton(),
        __metadata("design:paramtypes", [TimeoutScheduler])
    ], IpScheduler);

    const documentParser = (data) => {
        var _a, _b, _c, _d;
        if (!data) {
            throw new MissingDataError(MissingDataMessage.TokenData);
        }
        const { gc_transaction_id, result, state, product } = data;
        const parsed = {
            gcTransactionId: gc_transaction_id !== null && gc_transaction_id !== void 0 ? gc_transaction_id : '',
            result: result !== null && result !== void 0 ? result : false,
            region: state !== null && state !== void 0 ? state : '',
            product: product !== null && product !== void 0 ? product : '',
            submitIpAddress: undefined,
        };
        if (Object.entries(data).length !== 0 && result) {
            return Object.assign(Object.assign({}, parsed), { expires: (_a = data.expires) !== null && _a !== void 0 ? _a : '', geolocateIn: (_b = data.geolocate_in) !== null && _b !== void 0 ? _b : 0, countryCode: (_c = data.country_code) !== null && _c !== void 0 ? _c : '', regionCode: (_d = data.region_code) !== null && _d !== void 0 ? _d : '', sessionId: data.session_id, products: data.products });
        }
        if ((data === null || data === void 0 ? void 0 : data.troubleshooter) && (data === null || data === void 0 ? void 0 : data.troubleshooter.length) > 0 && !result) {
            return Object.assign(Object.assign({}, parsed), { errorMessage: data.error_message, troubleshooter: data.troubleshooter.map((err) => ({
                    message: err.message,
                    rule: err.rule,
                    retry: err.retry,
                    helpLink: err === null || err === void 0 ? void 0 : err.help,
                    optInLink: err === null || err === void 0 ? void 0 : err.opt_in,
                    title: err === null || err === void 0 ? void 0 : err.title,
                })), errorDetails: data.error_details, sessionId: data.session_id });
        }
    };
    const decodeAndParseToken = (token) => {
        try {
            if (!token) {
                throw new MissingDataError(MissingDataMessage.LocationToken);
            }
            const decodedToken = jwtDecode__default["default"](token);
            return documentParser(decodedToken);
        }
        catch (err) {
            throw err;
        }
    };
    const processGeolocationCheckResponse = (response) => {
        const jwt = response.geolocation_token;
        const ipAddress = response.ip_address;
        const parsedToken = decodeAndParseToken(jwt);
        if (ipAddress) {
            parsedToken.submitIpAddress = ipAddress;
        }
        return {
            jwt,
            token: parsedToken,
        };
    };
    const timeForRenewal = (renewalTimeMs, now = Date.now()) => {
        return renewalTimeMs - now;
    };
    const isTokenActive = (expiry, currentTime = new Date()) => {
        if (!expiry)
            return false;
        const expiryTime = toDate(expiry);
        if (expiryTime.toString() === 'Invalid Date')
            return false;
        return expiryTime.getTime() > currentTime.getTime();
    };
    function createBufferTime(geolocateIn) {
        if (geolocateIn < 30)
            return 0;
        return Math.min(geolocateIn * 0.3, (geolocateIn * 0.1) + 20, 120);
    }
    const getRenewalDate = (createBufferTime) => (token) => {
        const expiryTimeMs = new Date(token.expires).getTime();
        const bufferTimeMs = createBufferTime(token.geolocateIn) * 1000;
        return new Date(expiryTimeMs - bufferTimeMs);
    };
    const calculateTimeForRenewalMs = ({ createBufferTime }) => (token) => {
        const expiryCeilingTimeMs = (token.geolocateIn - createBufferTime(token.geolocateIn)) * 1000;
        const renewalDate = getRenewalDate(createBufferTime)(token);
        const renewalTimeMs = renewalDate.getTime();
        const timeForRenewalMs = timeForRenewal(renewalTimeMs);
        if (timeForRenewalMs < 0)
            return null;
        if (timeForRenewalMs > expiryCeilingTimeMs)
            return expiryCeilingTimeMs;
        return timeForRenewalMs;
    };
    /**
     * Implementation taken from Sportsbook
     * helper function to calculate the buffer time for re-geolocation
     */
    const getTimeForRenewalMs = calculateTimeForRenewalMs({
        createBufferTime,
    });
    const renewalDate = getRenewalDate(createBufferTime);
    const isTokenValidForProduct = (tokenProduct, tokenProducts, product) => {
        const allowableProducts = [tokenProduct, ...tokenProducts].filter((el) => el !== undefined);
        return allowableProducts.includes(product);
    };

    var Location$1;
    (function (Location) {
        Location["Token"] = "location token";
        Location["WrongStateError"] = "Wrong State";
        Location["WrongSessionError"] = "Wrong Session ID";
        Location["WrongProductError"] = "Wrong product";
        Location["GeoComplyRenewalDate"] = "GeoComplyRenewalDate";
        Location["jwtError"] = "Missing jwt in cache";
    })(Location$1 || (Location$1 = {}));

    /**
     * Error class thrown when geolocation token does not exist in cache
     */
    class MissingLocationTokenError extends BaseError {
        constructor(message = 'Location token is not in cache') {
            super(message);
        }
    }
    /**
     * Error class thrown when geolocation token is invalid
     */
    class InvalidLocationToken extends BaseError {
        constructor(reason) {
            super(`Location token in cache is invalid with reason: ${reason}`);
        }
    }
    /**
     * Error class thrown when geolocation token in cache fails
     * @remarks returns the failing token within the error obj
     */
    class LocationTokenFailedError extends BaseError {
        constructor(token) {
            super(`Location token in cache has failed rules`);
            this.token = token;
        }
    }
    /**
     * Error class thrown when geolocation token in cache has expired
     * @remarks returns the expired token within the error obj
     */
    class LocationTokenExpiredError extends BaseError {
        constructor(token) {
            super(`Location token in cache has expired`);
            this.token = token;
        }
    }

    let LocationCache = class LocationCache extends LocalCache {
        constructor(configSerivce) {
            super();
            this.configSerivce = configSerivce;
        }
        /**
         * @public Method to get location token from localStorage
         * @param {Date} todaysDate - defualt today's day (for testing purposes)
         * @returns {LocationToken} token
         * @throws {MissingLocationTokenError} when the token does not exist in cache
         * @throws error from isLocationTokenValid method when token is invalid
         */
        getLocationToken(todaysDate = new Date()) {
            const locationData = this.getItem(Location$1.Token);
            if (!locationData) {
                throw new MissingLocationTokenError();
            }
            try {
                if (this.isLocationTokenValid(locationData, todaysDate)) {
                    /**
                     * if token is valid -> of type IGeolocationSuccessTokenDocument
                     */
                    return locationData;
                }
            }
            catch (err) {
                throw err;
            }
        }
        /**
         * @public Method to set new location token in localStorage
         * @param {LocationToken} tokenData - decrypted geopacket token
         * @returns {void}
         */
        setLocationToken(tokenData) {
            this.setItem(Location$1.Token, tokenData);
        }
        /**
         * @public Method to remove location token from localStorage
         * @returns {boolean} - inverse boolean value of getter
         */
        removeLocationToken() {
            this.removeItem(Location$1.Token);
        }
        /**
         * @public Method to get current user IP address from localStorage
         * @param {Date} todaysDate - defualt today's day (for testing purposes)
         * @returns {string} IP address
         */
        getIpAddress(todaysDate = new Date()) {
            try {
                if (!this.getLocationToken(todaysDate)) {
                    return undefined;
                }
                return this.getLocationToken(todaysDate).token.submitIpAddress;
            }
            catch (_a) {
                // handle error
            }
        }
        /**
         * @setter geoComplyRenewalDate
         */
        set geoComplyRenewalDate(renewalDate) {
            this.setItem(Location$1.GeoComplyRenewalDate, renewalDate);
        }
        /**
         * @getter geoComplyRenewalDate
         */
        get geoComplyRenewalDate() {
            try {
                const renewalDate = this.getItem(Location$1.GeoComplyRenewalDate);
                return renewalDate ? new Date(renewalDate) : null;
            }
            catch (err) {
                return null;
            }
        }
        /**
         * @public Method to remove the GeoComplyRenewalDate
         */
        removeGeoComplyRenewalDate() {
            this.removeItem(Location$1.GeoComplyRenewalDate);
        }
        /**
         * @public Method to clear all location data
         * 1. location token
         * 2. renewal date
         */
        clearLocationCache() {
            this.removeLocationToken();
            this.removeGeoComplyRenewalDate();
        }
        /**
         * @private Method to check whether the location token in cache is valid
         * To be valid it must pass three conditions:
         * 1. Token cached does not have failing rules
         * 2. Token cached has not expired
         * 3. Token cached is for the consumer product
         * @param {any} token - location token data
         * @returns {boolean}
         * @throws {InvalidLocationToken} when wrong state
         * @throws {LocationTokenFailedError} when the token fails
         * @throws {LocationTokenExpiredError} when the token in cache has expired
         */
        isLocationTokenValid(locationData, todaysDate = new Date()) {
            var _a;
            try {
                const { appDomain: { product, region }, session } = this.configSerivce;
                /**
                 * Product mapper is used as the product passed in config is full name 'sportsbook' -> returned from api is shortened: SB
                 */
                if (!locationData.token.result) {
                    throw new LocationTokenFailedError(locationData.token);
                }
                /**
                 * Result is true -> must be a successful geolocation
                 */
                const { token, jwt } = locationData;
                const tokenHasExpired = !isTokenActive(token.expires, todaysDate);
                const wrongState = region !== token.region;
                const wrongSessionID = session.sessionId !== token.sessionId.toString();
                const wrongProduct = product && !isTokenValidForProduct(token.product, (_a = token.products) !== null && _a !== void 0 ? _a : [], productMap(product));
                if (tokenHasExpired) {
                    throw new LocationTokenExpiredError(token);
                }
                if (wrongState) {
                    throw new InvalidLocationToken(Location$1.WrongStateError);
                }
                if (wrongSessionID) {
                    throw new InvalidLocationToken(Location$1.WrongSessionError);
                }
                if (wrongProduct) {
                    throw new InvalidLocationToken(Location$1.WrongProductError);
                }
                if (!jwt) {
                    throw new InvalidLocationToken(Location$1.jwtError);
                }
                return true;
            }
            catch (err) {
                throw err;
            }
        }
    };
    LocationCache = __decorate([
        tsyringe.singleton(),
        __metadata("design:paramtypes", [ConfigService])
    ], LocationCache);

    var LocationRoute;
    (function (LocationRoute) {
        LocationRoute["IPAddress"] = "/client/connection-info";
        LocationRoute["GeolocationCheck"] = "/geocomply/submit";
    })(LocationRoute || (LocationRoute = {}));

    let LocationAPI = class LocationAPI extends HttpService {
        constructor(configService, loggerService) {
            super(configService, loggerService);
            this.configService = configService;
        }
        /**
         * @public Method to get the users current IP address
         * @remarks - retries 5 times with a 2000 second delay upon failure
         * @returns {Promise<string>}
         * @throws {ApiError} generic api error
         */
        getUsersIpAddress() {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    const { ip_address: ipAddress } = yield this.get(LocationRoute.IPAddress);
                    return ipAddress;
                }
                catch (err) {
                    /**
                     * throw api error - will alaways retry 5 times
                     */
                    throw new ApiError();
                }
            });
        }
        /**
         * @public Method to POST the encrypted geopacket to FD server for decryption
         * @param {string} geopacket - encrypted GeoPacket from GeoComply
         * @returns {Promise<IGeoLocationCheck>}  JWT geolocationCheck
         * @throws {SubmitWithoutRetryError} if status error is 400
         * @throws {SubmitError} if retries fail & 500 error
         * @throws {ApiError} generic api error
         */
        decryptGeoPacket(geopacket) {
            return __awaiter(this, void 0, void 0, function* () {
                const userAuthExtraHeaders = { 'x-auth-token': this.configService.session.userAuthToken };
                const params = null;
                try {
                    const response = (yield this.post(LocationRoute.GeolocationCheck, {
                        geopacket,
                        state: this.configService.appDomain.region.toUpperCase(),
                        product: productMap(this.configService.appDomain.product),
                    }, params, userAuthExtraHeaders));
                    const geolocationCheck = first(response.geolocation_check);
                    return geolocationCheck;
                }
                catch (error) {
                    if (error.response) {
                        const { response: { status }, } = error;
                        /**
                         * HTTP 4xx fail with no retry
                         */
                        if (http400Match(status)) {
                            throw new SubmitWithoutRetryError();
                        }
                        /**
                         * HTTP 5xx fail with retry
                         */
                        if (http500Match(status)) {
                            throw new SubmitError();
                        }
                    }
                    /**
                     * Throw generic error
                     */
                    throw new ApiError();
                }
            });
        }
    };
    __decorate([
        canRetry({ maxRetries: 5, retryErrors: [ApiError], timeoutDuration: 1000 }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", Promise)
    ], LocationAPI.prototype, "getUsersIpAddress", null);
    __decorate([
        canRetry({ maxRetries: 5, retryErrors: [SubmitError], timeoutDuration: 1000 }),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", Promise)
    ], LocationAPI.prototype, "decryptGeoPacket", null);
    LocationAPI = __decorate([
        tsyringe.singleton(),
        __metadata("design:paramtypes", [ConfigService, LoggerService])
    ], LocationAPI);

    var Location;
    (function (Location) {
        Location[Location["IpInterval"] = 15000] = "IpInterval";
    })(Location || (Location = {}));

    /**
     * Class to handle the timeout for re-geolocating
     * The SDK must re-geolocate based on the api response
     */
    let GeolocateScheduler = class GeolocateScheduler {
        /**
         * @param timeoutScheduler instance of timeout class
         */
        constructor(timeoutScheduler) {
            this.timeoutScheduler = timeoutScheduler;
        }
        /**
         * @public method to start the geolocation timer
         * @param interval time to geolocate
         * @param geolocate callback function to run after interval
         */
        startTimer(interval, geolocate) {
            /** stop any timer currently scheduled and replace */
            if (this.isSet()) {
                this.stopTimer();
            }
            this.timeoutScheduler.startTimer(interval, geolocate);
        }
        /**
         * @public method to stop the geolocation timer
         * @returns void
         */
        stopTimer() {
            this.timeoutScheduler.stopTimer();
        }
        /**
         * @public method to check if the geolocation timeoutScheduler is set
         * @returns boolean
         */
        isSet() {
            return this.timeoutScheduler.timerSet();
        }
    };
    GeolocateScheduler = __decorate([
        tsyringe.singleton(),
        __metadata("design:paramtypes", [TimeoutScheduler])
    ], GeolocateScheduler);

    class SuccessLocationToken {
        constructor(locationResponseToken) {
            this.locationResponseToken = locationResponseToken;
            this.locationResponseToken = locationResponseToken;
        }
        get hasToken() {
            var _a;
            return !this.locationResponseToken ? false : Boolean((_a = this.locationResponseToken) === null || _a === void 0 ? void 0 : _a.token);
        }
        /**
         *
         * @param renewalDate date to check against the expiry date
         * @returns {boolean}
         */
        hasValidRenewal(renewalDate, now = new Date()) {
            try {
                if (!renewalDate || !this.hasToken) {
                    return false;
                }
                /**
                 * check renewal hasn't passed
                 */
                const renewalMs = renewalDate.getTime();
                const nowMs = now.getTime();
                const renewalPast = renewalMs <= nowMs;
                if (renewalPast) {
                    return false;
                }
                const { expires } = this.locationResponseToken.token;
                const tokenExpiryDate = new Date(expires);
                /**
                 * compare renewal time to expiry
                 */
                return tokenExpiryDate.getTime() > renewalDate.getTime();
            }
            catch (err) {
                return false;
            }
        }
    }

    /**
     * Class to handle any logic directly related to the location. Primarily - the methods are to be called within the geolocator client class
     * At a glace, the class handles:
     * 1. IP changed logic
     */
    let LocationService = class LocationService {
        constructor(locationCache, locationAPI, geoComplyProvider, ipScheduler, geolocateScheduler) {
            this.locationCache = locationCache;
            this.locationAPI = locationAPI;
            this.geoComplyProvider = geoComplyProvider;
            this.ipScheduler = ipScheduler;
            this.geolocateScheduler = geolocateScheduler;
            /**
             * @public Method to set the start geolocation callback within handleIpChange memory
             * @param {startGeolocation} startGeolocation - Client (geolocator) method to run when user ip changes
             * @returns function to get the users ip and cross reference with what is currently stored in memory
             */
            this.ipChangeHandler = (startGeolocation) => {
                if (!startGeolocation || typeof startGeolocation !== 'function') {
                    throw 'missing start geolocation method';
                }
                /**
                 * @function handleIpChange passed to the ip scheduler to run every 15 seconds
                 * Includes startGeolocatin callback passed as argument to outerfunction
                 */
                const handleIpChange = (reason) => __awaiter(this, void 0, void 0, function* () {
                    try {
                        const usersCurrentIpAddress = yield this.locationAPI.getUsersIpAddress();
                        const IPCachedFromToken = this.locationCache.getIpAddress();
                        if (!IPCachedFromToken) {
                            return;
                        }
                        if (IPCachedFromToken === usersCurrentIpAddress) {
                            return;
                        }
                        this.locationCache.clearLocationCache();
                        return startGeolocation(reason);
                    }
                    catch (err) {
                        /**
                         * Error thrown within ip scheduler method: (ipScheduler.startTimer)
                         */
                        throw err;
                    }
                });
                return handleIpChange;
            };
        }
        /** Method to start the connection with GeoComply service
         * @param {IEnviromentDetails} config - data required for GeoComply SDK
         * @param handleGeoComplyError - callback to fire onError event
         * @param onGeolocation - callback to fire onGeolocation event
         * @param onConnect - callback to fire onConnect event
         */
        startGeolocationProvider(config, handleGeoComplyError, onGeolocation, onConnect) {
            this.geoComplyProvider.connect(config, handleGeoComplyError, onGeolocation, onConnect);
        }
        /**
         * @public Method to geolocate user with license
         * @param {string} license string passed to geoComply sdk
         * @param {string} reason string passed to geoComply sdk
         * @throws errors to be handled by the delegate method
         */
        geolocateWithLicense(license, reason) {
            try {
                this.geoComplyProvider.geolocateUser(license, reason);
            }
            catch (err) {
                throw err;
            }
        }
        /**
         * @public Method to kill all methods for location services
         * 1. stop web-sockets connection
         * 2. stop both ip & geolocate schedulers
         * 3. clear location token from cache
         */
        resetLocation() {
            this.geoComplyProvider.disconnect();
            this.stopSchedulers();
            this.clearLocationData();
        }
        /**
         * @public Method to clear the location token from cache
         */
        clearLocationData() {
            this.locationCache.clearLocationCache();
        }
        /**
         * @public Method to start the ip scheduler after the first successful geolocation
         * @param {startGeolocation} startGeolocation - primary method from geolocator to run when ip address changes
         * @param errorHandler - callback to handle errors
         */
        startIpScheduler(startGeolocation, errorHandler) {
            /**
             * Set the restart geolocation callback for unsuccessful ip check
             */
            const handleIpChange = this.ipChangeHandler(startGeolocation);
            /**
             * Start ip scheduler if not already started
             */
            if (!this.ipScheduler.isSet()) {
                this.ipScheduler.startTimer(Location.IpInterval, handleIpChange, errorHandler);
            }
        }
        /**
         * @public Method to stop all location schedulers
         * 1. ipScheduler
         * 2. geolocateScheduler
         */
        stopSchedulers() {
            this.ipScheduler.stopTimer();
            this.geolocateScheduler.stopTimer();
        }
        /**
         * @public Method to start the timer for re-geolocating
         * @param {number} reGeolocateInterval time to run the startGeolocation method
         * @param {startGeolocation} startGeolocation method to run everytime timer ends
         * @returns {void}
         */
        startGeolocationScheduler(reGeolocateInterval, callback) {
            try {
                this.geolocateScheduler.startTimer(reGeolocateInterval, callback);
            }
            catch (err) {
                throw err;
            }
        }
        /**
         * @public Method to check the status of the geolocation scheduler
         * @returns {boolean}
         */
        geolocationSchedulerSet() {
            return this.geolocateScheduler.isSet();
        }
        /**
         *@public method to stop geolocator scheduler
         */
        stopGeolocationScheduler() {
            this.geolocateScheduler.stopTimer();
        }
        /**
         * @public Method to handle decrypt of the geopacket and parse the token response.
         * It also sets the parsed token in cache
         * @param {string} geoPacket - encrypted location response from GeoComply
         * @returns {Promise<LocationToken>}
         * @throws error from POST decryptGeoPacket request
         */
        processGeocomplyGeopacket(geoPacket) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    const geolocationCheck = yield this.performLocationTokenRequest(() => this.locationAPI.decryptGeoPacket(geoPacket));
                    const parsedGeolocationToken = processGeolocationCheckResponse(geolocationCheck);
                    this.locationCache.setLocationToken(parsedGeolocationToken);
                    return parsedGeolocationToken;
                }
                catch (err) {
                    throw err;
                }
            });
        }
        /**
         * @public Method to get a valid location token from cache (localstorage)
         */
        getValidLocationToken() {
            try {
                const validToken = this.locationCache.getLocationToken();
                return new SuccessLocationToken(validToken);
            }
            catch (err) {
                /**
                 * Invalid - clear location token from cache
                 */
                this.clearLocationData();
                if (err instanceof InvalidLocationToken ||
                    err instanceof LocationTokenExpiredError ||
                    err instanceof LocationTokenFailedError ||
                    err instanceof MissingLocationTokenError) {
                    return null;
                }
                /**
                 * throw generic error
                 */
                throw err;
            }
        }
        /**
         * @public Method to set the renewal date to location cache
         * @param renewalDate
         */
        setRenewalDate(renewalDate) {
            this.locationCache.geoComplyRenewalDate = renewalDate;
        }
        /**
         * @public Method to get the renewal date from location cache
         */
        getRenewalDate() {
            return this.locationCache.geoComplyRenewalDate;
        }
        /**
         * @private Method to request the geolocation_check from GC geopacket
         * @param promiseRequest method to make the request - allows the ability to compose any request method (GET OR POST)
         * @returns formatted location token object when sucessful
         * @throws error from the network request callback call
         */
        performLocationTokenRequest(promiseRequest) {
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    const response = yield promiseRequest();
                    return response;
                }
                catch (err) {
                    throw err;
                }
            });
        }
    };
    LocationService = __decorate([
        tsyringe.singleton(),
        __metadata("design:paramtypes", [LocationCache,
            LocationAPI,
            GeoComplyProvider,
            IpScheduler,
            GeolocateScheduler])
    ], LocationService);

    /**
     * Utility function to create actions of differing actions and types
     * @param action - action type
     * @returns Function
     */
    const actionCallbackBuilder = (actionType) => (type) => (errorCode) => (extraArgs) => {
        return {
            type: actionType,
            payload: Object.assign({}, (errorCode !== undefined
                ? {
                    error: Object.assign({ type,
                        errorCode }, extraArgs),
                }
                : Object.assign({}, extraArgs))),
        };
    };
    /**
     * Action builders
     */
    const locationFailureBuilder = actionCallbackBuilder(LOCATION_FAILURE);
    const geolocationRejectedBuilder = actionCallbackBuilder(GEOLOCATION_REJECTED);
    const geolocationPassedBuilder = actionCallbackBuilder(GEOLOCATION_PASSED);
    const geolocationInProgressBuilder = actionCallbackBuilder(LOCATION_IN_PROGRESS);
    /**
     * Location failure actions
     */
    const apiFailureAction = locationFailureBuilder(API_ERROR)(GCError.API_ERROR);
    const fetchLicenseFailureAction = locationFailureBuilder(FETCH_LICENSE_ERROR)(GCError.FETCH_LICENSE_ERROR);
    const fetchLicenseWithoutRetryFailureAction = locationFailureBuilder(FETCH_LICENSE_WITHOUT_RETRY_ERROR)(GCError.FETCH_LICENSE_WITHOUT_RETRY_ERROR);
    locationFailureBuilder(IN_PROGRESS_ERROR)(GCError.REQUEST_GEOLOCATION_IN_PROGRESS);
    const missingDataFailureAction = locationFailureBuilder(MISSING_DATA_ERROR)(GCError.MISSING_DATA_ERROR);
    const submitFailureAction = locationFailureBuilder(SUBMIT_ERROR)(GCError.SUBMIT_ERROR);
    const submitWithoutRetryFailureAction = locationFailureBuilder(SUBMIT_WITHOUT_RETRY_ERROR)(GCError.SUBMIT_ERROR_WITHOUT_RETRY);
    const thresholdLimitFailureAction = locationFailureBuilder(THRESHOLD_LIMIT_ERROR)(GCError.THRESHOLD_LIMIT_ERROR);
    const osFailureAction = locationFailureBuilder(OS_ERROR)(GCError.OS_ERROR);
    /** Can be multiple error codes - error code to be passed dynamically */
    const plcFailureAction = locationFailureBuilder(PLC_ERROR);
    const locationRequestFailureAction = locationFailureBuilder(LOCATION_REQUEST_ERROR);
    /**
     * Geolocation result actions - passed or rejected
     */
    const geolocationRejectedAction = geolocationRejectedBuilder()();
    const geolocationPassedAction = geolocationPassedBuilder()();
    /**
     * Geolocation in progress action
     */
    const geolocationInProgressAction = geolocationInProgressBuilder()();
    /**
     * Replace values
     */
    const replaceIp = replace('Ip')('IP');
    const replaceAdb = replace('Adb')('ADB');
    const replaceVpn = replace('Vpn')('VPN');
    const replaceIos = replace('Ios')('IOS');
    /**
     * Format the tile for geolocation rejection - the rule is used to construct a title string if one doesnt exist
     * @param rule string from geocomply rejection
     */
    const formatTitle = pipe(replaceUnderscore, capitalise, replaceIp, replaceAdb, replaceVpn, replaceIos);

    /**
     * Service to limit and manage the amount of geolocation retries possible
     */
    let RequestLimiter = class RequestLimiter {
        constructor() {
            this.count = 0;
            this.threshold = 3;
        }
        /**
         * @public method to adjust the threshold based on the Geocomply errorcode
         * The error codes specified are those that are safe guarded from potentially retrying
         * @param errorCode - errorcode from geocomply
         * @returns void
         */
        statusForFailure(errorCode) {
            switch (errorCode) {
                case GCError.LICENSE_EXPIRED:
                case GCError.INVALID_LICENSE_FORMAT:
                case GCError.CLIENT_LICENSE_UNAUTHORIZED:
                case GCError.TRANSACTION_TIMEOUT:
                case GCError.LOCAL_SERVICE_COMMUNICATION:
                    return this.adjustThreshold(`GeoComply error: ${errorCode}`);
            }
        }
        /**
         * @public method to adjust the threshold based on the token
         * 1. successful geolocation - reset the threshold
         * 2. retry is possible as specified from the token - increase the threshold by 1 to avoid spamming
         * @param token location token returned from the FD api
         * @returns void
         */
        statusForLocationToken(token) {
            const errorMessage = 'Unknown Error';
            /**
             * reset the request limiter on successful token
             * */
            if (token.result) {
                this.reset();
            }
            /**
             * Retry is possible - increase the threshold by 1
             */
            if (this.hasRetryInPayload(token)) {
                const failureDocument = token;
                this.adjustThreshold(failureDocument.errorMessage || errorMessage);
            }
        }
        /**
         * @public method to check if failed the token returned from Geocomply can be retried.
         * @param token location token returned from the FD api
         * @returns boolean
         */
        hasRetryInPayload(token) {
            const messages = token.troubleshooter;
            if (!messages) {
                return false;
            }
            return messages.some((message) => message.retry);
        }
        /**
         * @public method to reset the request limit
         * @returns void
         */
        reset() {
            this.count = 0;
        }
        /**
         * @private method to increase the threshold by one
         * @param message threshold message
         * @returns void
         * @throws ThresholdLimitError if the count is >= than than the set threshold
         */
        adjustThreshold(message) {
            this.count++;
            if (this.count >= this.threshold) {
                throw new ThresholdLimitError(`${message}: count: ${this.count}`);
            }
        }
    };
    RequestLimiter = __decorate([
        tsyringe.injectable(),
        __metadata("design:paramtypes", [])
    ], RequestLimiter);

    /**
     * SDK Client class
     */
    let GeoLocator = class GeoLocator {
        /**
         * @param configService
         * @param licenseService
         * @param locationService
         * @param geoComplyProvider
         * @param requestLimiter
         */
        constructor(configService, licenseService, locationService, geoComplyProvider, requestLimiter) {
            this.configService = configService;
            this.licenseService = licenseService;
            this.locationService = locationService;
            this.geoComplyProvider = geoComplyProvider;
            this.requestLimiter = requestLimiter;
            /**
             * @public Method to start geolocation.
             * 1. sets callback with InProgressAction
             * 2. gets the license from license service
             * 3. starts geolocation process with license using the location service
             * @param {string} reason
             * @param {ILicenseOptions} licenseOptions - options passed in to alter the license request
             * @returns {Promise<void>}
             */
            this.startGeolocation = (reason, licenseOptions) => __awaiter(this, void 0, void 0, function* () {
                /** Alert consumer app geolocation has started */
                this.geolocationInProgress();
                /** Clear potential geolocation scheduler methods already set */
                this.locationService.stopGeolocationScheduler();
                try {
                    /**
                     * Get license for GeoComply SDK
                     */
                    const geoComplyLicense = yield this.licenseService.fetchLicense(licenseOptions);
                    this.locationService.geolocateWithLicense(geoComplyLicense, reason);
                }
                catch (err) {
                    /**
                     * Upon failure - run error handler with err instance
                     */
                    this.handleGeolocationError(err);
                }
            });
            /**
             * @public Method to start geolocation again - but requesting a new license
             * @returns {void}
             */
            this.refreshGeolocation = () => {
                this.startGeolocation(Reasons.REFRESH_REASON, { refreshLicense: true });
            };
            /**
             * @public Method passed as a callback to the web-sockets listening for onGeolocation event
             * @param {string} geopacket
             */
            this.onGeolocated = (geopacket) => __awaiter(this, void 0, void 0, function* () {
                try {
                    const locationData = yield this.locationService.processGeocomplyGeopacket(geopacket);
                    /**
                     * check request limiter
                     */
                    this.requestLimiter.statusForLocationToken(locationData.token);
                    if (locationData.token.result) {
                        const { token: geoSuccessDocument, jwt } = locationData;
                        const timeToRegeolocateMs = getTimeForRenewalMs(geoSuccessDocument);
                        /**
                         * for token caching purposes - do not remove
                         */
                        const dateForRenewal = renewalDate(geoSuccessDocument);
                        this.locationService.setRenewalDate(dateForRenewal);
                        /**
                         * start geolocator scheduler
                         */
                        this.startGeolocateScheduler(timeToRegeolocateMs);
                        this.geolocationPassed({ token: geoSuccessDocument, jwt });
                    }
                    else {
                        /**
                         * Unsuccessful geolocation response -> troubleshooter error message
                         */
                        const { token: geoFailureDocument, jwt } = locationData;
                        this.geolocationRejected({ token: geoFailureDocument, jwt });
                    }
                }
                catch (err) {
                    this.handleGeolocationError(err);
                }
            });
            /**
             * @public Method called once websockets are connected
             * @returns {void}
             */
            this.onConnect = () => {
                this.handleGeolocation(this.reason);
            };
            /**
             * @public Method to handle geolocation failure from various services
             * @param {CustomError} err - required to identify type of error
             * Stops all schedulers & returns error action to the consumer app
             * @returns {void}
             */
            this.handleGeolocationError = (err) => {
                var _a, _b, _c, _d;
                const { message, errorCode } = err;
                const errorMessage = { error: message };
                /**
                 * geolocation in progress  -> error silently
                 */
                if (err instanceof InProgressError) {
                    return;
                }
                /**
                 * stop schedulers on error
                 */
                this.locationService.stopSchedulers();
                /**
                 * handle the errors not specfic to GeoComply
                 */
                let callbackAction;
                switch (true) {
                    case err instanceof MissingDataError:
                        callbackAction = missingDataFailureAction({ data: message });
                        break;
                    case err instanceof ApiError:
                        callbackAction = apiFailureAction(errorMessage);
                        break;
                    case err instanceof FetchLicenseError:
                        callbackAction = fetchLicenseFailureAction(errorMessage);
                        break;
                    case err instanceof FetchLicenseWithoutRetryError:
                        callbackAction = fetchLicenseWithoutRetryFailureAction(errorMessage);
                        break;
                    case err instanceof SubmitError:
                        callbackAction = submitFailureAction(errorMessage);
                        break;
                    case err instanceof SubmitWithoutRetryError:
                        callbackAction = submitWithoutRetryFailureAction(errorMessage);
                        break;
                    case err instanceof ThresholdLimitError:
                        callbackAction = thresholdLimitFailureAction({ limit: err.message });
                        break;
                    case err instanceof OsError:
                        callbackAction = osFailureAction();
                        break;
                    default:
                        callbackAction = locationRequestFailureAction(errorCode || GCError.UNKNOWN)({ message });
                        break;
                }
                let product = productMap((_b = (_a = this.configService) === null || _a === void 0 ? void 0 : _a.appDomain) === null || _b === void 0 ? void 0 : _b.product);
                if (product === 'UNKNOWN') {
                    product = undefined;
                }
                callbackAction.payload = Object.assign(Object.assign({}, callbackAction.payload), { product, region: (_d = (_c = this.configService) === null || _c === void 0 ? void 0 : _c.appDomain) === null || _d === void 0 ? void 0 : _d.region });
                this.callback(callbackAction);
            };
            /**
             * @public Method to handle GeoComply errors
             * @param {CustomError} errorCode
             * @returns {void}
             */
            this.handleGeoComplyError = ({ errorCode }) => {
                try {
                    /**
                     * Change to number to cover potential string passed from GeoComply
                     */
                    const errorNumber = Number(errorCode);
                    /**
                     * check request limiter - throw max threshold error when it reaches threshold limit
                     */
                    this.requestLimiter.statusForFailure(errorNumber);
                    if (errorNumber === GCError.LOCAL_SERVICE_COMMUNICATION) {
                        /**
                         * attempt to re-connect without stopping schedulers
                         */
                        return this.connect();
                    }
                    /**
                     * geolocation in progress  -> error silently
                     */
                    if (errorNumber === GCError.REQUEST_GEOLOCATION_IN_PROGRESS) {
                        return;
                    }
                    /**
                     * stop schedulers on error
                     */
                    this.locationService.stopSchedulers();
                    switch (errorNumber) {
                        case GCError.LOCAL_SERVICE_UNAVAILABLE:
                        case GCError.LOCAL_SERVICE_UNSUP_VER:
                        case GCError.NETWORK_CONNECTION:
                            this.callback(this.fetchPluginAction(errorNumber));
                            break;
                        case GCError.LICENSE_EXPIRED:
                        case GCError.INVALID_LICENSE_FORMAT:
                        case GCError.CLIENT_LICENSE_UNAUTHORIZED:
                        case GCError.TRANSACTION_TIMEOUT:
                            this.refreshGeolocation();
                            break;
                        case GCError.UNEXPECTED:
                        case GCError.NOT_CERTIFIED_BINARIES:
                        case GCError.CLIENT_SUSPENDED:
                        case GCError.DISABLED_SOLUTION:
                        case GCError.INVALID_CUSTOM_FIELDS:
                        case GCError.SERVER_COMMUNICATION:
                        case GCError.WRONG_OR_MISSING_PARAMETER:
                            this.callback(locationRequestFailureAction(errorNumber)());
                            break;
                        default:
                            this.callback(locationRequestFailureAction(errorNumber)());
                            break;
                    }
                }
                catch (err) {
                    if (err instanceof ThresholdLimitError) {
                        this.locationService.stopSchedulers();
                        return this.callback(thresholdLimitFailureAction({ limit: err.message }));
                    }
                    /**
                     * handle generic error
                     */
                    this.handleGeolocationError(err);
                }
            };
        }
        /**
         * @public Method called to get the reason code member variable
         * @returns {string}
         */
        get reason() {
            return this._reason || Reasons.DEFAULT_REASON;
        }
        /**
         * @public Method to initiate GeoComply SDK and start the geolocation process
         * Checks for websocket connection - if not connected, it attempts to connect
         * Websocket has connected - startGeolocation
         * @param {string} reason
         * @returns {void}
         */
        locateUser(reason) {
            this.geolocationInProgress();
            if (this.geoComplyProvider.isConnected()) {
                /**
                 * start geolocation process
                 */
                this.handleGeolocation(reason);
            }
            else {
                this._reason = reason;
                /**
                 * connect to websockets
                 */
                this.connect();
            }
        }
        /**
         * @public Method to handle geolocation - this is the primary method to check for potential cached token
         * Checks local cache for valid token
         * No token exists - start geolocation
         * Token exists - check geolocation schedulers
         * Alert consumer app if passed or starting geolocation
         * @param reason for potential new geolocation
         */
        handleGeolocation(reason) {
            try {
                const locationToken = this.locationService.getValidLocationToken();
                /**
                 * valid token not in cache - start geolocation instantly
                 */
                if (!(locationToken === null || locationToken === void 0 ? void 0 : locationToken.hasToken)) {
                    return this.startGeolocation(reason);
                }
                /**
                 * Alert consumer app they have passed geolocation
                 */
                this.geolocationPassed(locationToken.locationResponseToken);
                if (!this.locationService.geolocationSchedulerSet()) {
                    const renewalDate = this.locationService.getRenewalDate();
                    /**
                     * renewal date is missing - start geolocation instantly
                     */
                    if (!isDateInstance(renewalDate)) {
                        return this.startGeolocation(reason);
                    }
                    const timeToRenewalMs = timeForRenewal(renewalDate.getTime());
                    const renewalPassed = timeToRenewalMs <= 0;
                    if (renewalPassed) {
                        return this.startGeolocation(reason);
                    }
                    /**
                     * start geolocate scheduler if not already set
                     */
                    this.startGeolocateScheduler(timeToRenewalMs);
                }
            }
            catch (err) {
                this.handleGeolocationError(err);
            }
        }
        /**
         * @public Method to connect to geocomply websockets
         * @param reason reason for starting geolocation
         */
        connect() {
            try {
                const config = {
                    environment: this.configService.environment,
                    installerKey: this.configService.installerKey,
                };
                this.locationService.startGeolocationProvider(config, this.handleGeoComplyError, this.onGeolocated, this.onConnect);
            }
            catch (err) {
                this.handleGeolocationError(err);
            }
        }
        /**
         * @public Method to reset data used within the servcices
         * 1. reset license service
         * 2. reset location service
         * 3. reset request limiter
         * @returns {void}
         */
        reset() {
            this.licenseService.resetLicense();
            this.locationService.resetLocation();
            this.requestLimiter.reset();
        }
        /**
         * @public Method to set callback to the instance
         * @param {GeolocationCallback} cb
         * @returns {void}
         */
        setCallback(cb) {
            this.callback = cb;
        }
        /**
         * @public Method to start a new geolocation Scheduler
         * @param timeMs time for next geolocation
         */
        startGeolocateScheduler(timeMs) {
            this.locationService.startGeolocationScheduler(timeMs, () => this.startGeolocation(Reasons.REFRESH_REASON));
        }
        /**
         * @private Method to start ip scheduler
         * @returns void
         */
        startIpScheduler() {
            this.locationService.startIpScheduler(this.startGeolocation, this.handleGeolocationError);
        }
        /**
         * @private Method to call callback with geolocation passed action and start ip scheduler
         * When geolocation has passed we must enusre the ip scheduler is polling for ip
         * @param geoSuccessDocument - parsed document
         */
        geolocationPassed(locationDataSuccess) {
            try {
                /**
                 * start ip polling if not already running
                 */
                this.startIpScheduler();
                /**
                 * Successful geolocation response
                 */
                const passedPayload = this.formatGeolocationPassedPayload(locationDataSuccess);
                this.callback(geolocationPassedAction(passedPayload));
            }
            catch (err) {
                this.handleGeolocationError(err);
            }
        }
        /**
         * @private Method to handle geolocaiton rejected
         * 1.Alerts consumer app geolocation has been rejected
         * 2.Stops schedulers
         * @param geoFailureDocument - parsed document
         */
        geolocationRejected(locationDataRejected) {
            try {
                const rejectionPayload = this.formatGeolocationRejectionPayload(locationDataRejected);
                this.callback(geolocationRejectedAction(rejectionPayload));
                /**
                 * stop schedulers on geolocation rejection
                 */
                this.locationService.stopSchedulers();
            }
            catch (err) {
                this.handleGeolocationError(err);
            }
        }
        /**
         * @private Method to format the passed data returned to the consumer application
         * @param locationDataSuccess - location passed token from geocomply
         * @returns formated passed data
         */
        formatGeolocationPassedPayload(locationDataSuccess) {
            const { token, jwt } = locationDataSuccess;
            return {
                product: token.product,
                region: token.region,
                jwt,
            };
        }
        /**
         * @private Method to format the in progress data returned to the consumer application
         * @returns formated in progress data
         */
        formatGeolocationInProgressPayload() {
            var _a, _b, _c, _d;
            const currentProduct = productMap((_b = (_a = this.configService) === null || _a === void 0 ? void 0 : _a.appDomain) === null || _b === void 0 ? void 0 : _b.product);
            return {
                product: currentProduct === 'UNKNOWN' ? undefined : currentProduct,
                region: (_d = (_c = this.configService) === null || _c === void 0 ? void 0 : _c.appDomain) === null || _d === void 0 ? void 0 : _d.region
            };
        }
        /**
         * @private Method to format the rejection data to be returned to the consumer application
         * @param locationDataRejected location rejected token from geocomply
         * @returns formatted rejection data
         */
        formatGeolocationRejectionPayload(locationDataRejected) {
            try {
                const { region, product, errorMessage, troubleshooter } = locationDataRejected.token;
                /**
                 * Parse troubleshooters
                 */
                const troubleshooters = troubleshooter.map((data) => {
                    const formattedTroubleShooter = Object.assign(Object.assign({}, data), { 
                        /** when a title doesnt already exist - it uses the rule */
                        title: data.title ? data.title : formatTitle(data.rule) });
                    return formattedTroubleShooter;
                });
                return {
                    product,
                    region,
                    rejection: {
                        message: errorMessage,
                        troubleshooters,
                    },
                };
            }
            catch (err) {
                this.handleGeolocationError(err);
            }
        }
        /**
         * @private Method to call callback function with inProgressAction
         */
        geolocationInProgress() {
            this.callback(geolocationInProgressAction(this.formatGeolocationInProgressPayload()));
        }
        /**
         * @private Method to return the plugin failure action
         * @param {number} errCode
         * @returns {CallbackAction}
         */
        fetchPluginAction(errCode) {
            try {
                /**
                 * Get plugin url for consumer application
                 */
                const pluginUrl = this.geoComplyProvider.requestPluginUrl();
                const pluginErrorAction = plcFailureAction(errCode)({ url: pluginUrl });
                /**
                 * Call callback to consumer app
                 */
                return pluginErrorAction;
            }
            catch (err) {
                this.handleGeolocationError(err);
            }
        }
    };
    GeoLocator = __decorate([
        tsyringe.injectable(),
        __metadata("design:paramtypes", [ConfigService,
            LicenseService,
            LocationService,
            GeoComplyProvider,
            RequestLimiter])
    ], GeoLocator);

    /**
     * Geolocation SDK initaliser class
     */
    exports.Geolocation = class Geolocation {
        /**
         * Injects all dependancies
         * @throws Error 'SDK not running in browser' when SDK is initialised outside of the browser environment
         */
        constructor(geoLocatorService, configService) {
            this.geoLocatorService = geoLocatorService;
            this.configService = configService;
            if (!isBrowser)
                throw new Error('SDK not running in browser');
        }
        /**
         * @public Starts the SDK with a given config object. It will set the config service with user
         * and session data. If session is undefined, it will reset the SDK.
         * Promise will reject if config failed to be set.
         * @remarks This method must always be a promise to align with the shared interface
         * @param {Config} configObject
         * @throws {MissingDataError} if the config is missing required data
         * @returns {Promise<boolean>}
         */
        setConfig(configObject) {
            return new Promise((resolve, reject) => {
                if (!configObject.clientAuthToken) {
                    throw new MissingDataError(MissingDataMessage.ClientAuthToken);
                }
                if (!configObject.appDomain.product) {
                    throw new MissingDataError(MissingDataMessage.AppDomainProduct);
                }
                if (!configObject.environment) {
                    throw new MissingDataError(MissingDataMessage.EnvironmentType);
                }
                if (!configObject.installerKey) {
                    throw new MissingDataError(MissingDataMessage.InstallerKey);
                }
                if (!configObject.appVersion) {
                    throw new MissingDataError(MissingDataMessage.AppVersion);
                }
                if (!configObject.appName) {
                    throw new MissingDataError(MissingDataMessage.AppName);
                }
                if (configObject.session) {
                    const { userAuthToken, userId, sessionId } = configObject.session;
                    if (!userAuthToken) {
                        throw new MissingDataError(MissingDataMessage.SessionAuthToken);
                    }
                    if (!userId) {
                        throw new MissingDataError(MissingDataMessage.SessionUserId);
                    }
                    if (!sessionId) {
                        throw new MissingDataError(MissingDataMessage.SessionId);
                    }
                    try {
                        this.configService.setConfig(geoLocationConfigParser(configObject));
                        resolve(true);
                    }
                    catch (err) {
                        reject(err);
                    }
                }
                else {
                    this.geoLocatorService.reset();
                    resolve(true);
                }
            });
        }
        /**
         * @public Sets callback function within SDK
         * @param {GeolocationCallback} cb - callback function
         */
        setCallback(cb) {
            this.callback = cb;
            this.geoLocatorService.setCallback(cb);
        }
        /**
         * @public Interface method for consumer app to start geolocation
         * @param {string} reason - value passed to the GeoComply SDK
         * @throws {MissingDataError} when config has not been set
         */
        locateUser(reason) {
            if (!this.configService.isSet) {
                throw new MissingDataError();
            }
            else {
                this.geoLocatorService.locateUser(reason);
            }
        }
    };
    exports.Geolocation = __decorate([
        tsyringe.injectable(),
        __metadata("design:paramtypes", [GeoLocator, ConfigService])
    ], exports.Geolocation);

    let AWSDKInit = class AWSDKInit {
        init(config) {
            registerConfigService(config);
            const _realityCheck = tsyringe.container.resolve(RealityCheck);
            const _account = tsyringe.container.resolve(exports.Account);
            return {
                realityCheck: () => _realityCheck,
                account: () => _account,
            };
        }
    };
    AWSDKInit = __decorate([
        tsyringe.injectable()
    ], AWSDKInit);
    let SDKGeoLocation = class SDKGeoLocation {
        initGeolocation() {
            registerConfigService();
            return tsyringe.container.resolve(exports.Geolocation);
        }
    };
    SDKGeoLocation = __decorate([
        tsyringe.injectable()
    ], SDKGeoLocation);
    let SDKAccount = class SDKAccount {
        initAccount() {
            registerConfigService();
            return tsyringe.container.resolve(exports.Account);
        }
    };
    SDKAccount = __decorate([
        tsyringe.injectable()
    ], SDKAccount);
    const registerConfigService = (config) => {
        if (!tsyringe.container.isRegistered(ConfigService)) {
            tsyringe.container.register(ConfigService, {
                useValue: new ConfigService(config ? new BaseSDKInitConfig(config) : undefined),
            });
        }
    };
    const awSDK = () => tsyringe.container.resolve(AWSDKInit);
    const geoLocationSDK = () => tsyringe.container.resolve(SDKGeoLocation).initGeolocation();
    const accountSDK = () => tsyringe.container.resolve(SDKAccount).initAccount();

    exports.AccountHomeView = AccountHomeView;
    exports.AccountSDKConfig = AccountSDKConfig;
    exports.BaseSDKInitConfig = BaseSDKInitConfig;
    exports.ValidatingSDKInitConfig = ValidatingSDKInitConfig;
    exports.accountSDK = accountSDK;
    exports.awSDK = awSDK;
    exports.geoLocationSDK = geoLocationSDK;

    Object.defineProperty(exports, '__esModule', { value: true });

}));
